var items = {
  "block.minecraft.acacia_button": "აკაციის ღილაკი",
  "block.minecraft.acacia_door": "აკაციის კარი",
  "block.minecraft.acacia_fence": "აკაციის ღობე",
  "block.minecraft.acacia_fence_gate": "აკაციის ჭიშკარი",
  "block.minecraft.acacia_hanging_sign": "აკაციის საკიდი აბრა",
  "block.minecraft.acacia_leaves": "აკაციის ფოთლები",
  "block.minecraft.acacia_log": "აკაციის მორი",
  "block.minecraft.acacia_planks": "აკაციის ფიცრები",
  "block.minecraft.acacia_pressure_plate": "აკაციის საჭერი ფირფიტა",
  "block.minecraft.acacia_sapling": "აკაციის ნერგი",
  "block.minecraft.acacia_shelf": "აკაციის თარო",
  "block.minecraft.acacia_sign": "აკაციის აბრა",
  "block.minecraft.acacia_slab": "აკაციის ფილა",
  "block.minecraft.acacia_stairs": "აკაციის საფეხურები",
  "block.minecraft.acacia_trapdoor": "აკაციის სარკმელი",
  "block.minecraft.acacia_wall_hanging_sign": "აკაციის კედლის საკიდი აბრა",
  "block.minecraft.acacia_wall_sign": "აკაციის კედლის აბრა",
  "block.minecraft.acacia_wood": "აკაციის მერქანი",
  "block.minecraft.activator_rail": "ჩამრთველი ლიანდაგი",
  "block.minecraft.air": "ჰაერი",
  "block.minecraft.allium": "ჭლაკვი",
  "block.minecraft.amethyst_block": "ამეთვისტოს ბლოკი",
  "block.minecraft.amethyst_cluster": "ამეთვისტოს დრუზა",
  "block.minecraft.ancient_debris": "ძირძველი ნატეხები",
  "block.minecraft.andesite": "ანდეზიტი",
  "block.minecraft.andesite_slab": "ანდეზიტის ფილა",
  "block.minecraft.andesite_stairs": "ანდეზიტის საფეხურები",
  "block.minecraft.andesite_wall": "ანდეზიტის ზღუდე",
  "block.minecraft.anvil": "გრდემლი",
  "block.minecraft.attached_melon_stem": "მიბმული საზამთროს ღერო",
  "block.minecraft.attached_pumpkin_stem": "მიბმული გოგრის ღერო",
  "block.minecraft.azalea": "აზალია",
  "block.minecraft.azalea_leaves": "აზალიას ფოთლები",
  "block.minecraft.azure_bluet": "ცისფერი ჟასმინი",
  "block.minecraft.bamboo": "ბამბუკი",
  "block.minecraft.bamboo_block": "ბამბუკის ბლოკი",
  "block.minecraft.bamboo_button": "ბამბუკის ღილაკი",
  "block.minecraft.bamboo_door": "ბამბუკის კარი",
  "block.minecraft.bamboo_fence": "ბამბუკის ღობე",
  "block.minecraft.bamboo_fence_gate": "ბამბუკის ჭიშკარი",
  "block.minecraft.bamboo_hanging_sign": "ბამბუკის საკიდი აბრა",
  "block.minecraft.bamboo_mosaic": "ბამბუკის მოზაიკა",
  "block.minecraft.bamboo_mosaic_slab": "ბამბუკის მოზაიკის ფილა",
  "block.minecraft.bamboo_mosaic_stairs": "ბამბუკის მოზაიკის საფეხურები",
  "block.minecraft.bamboo_planks": "ბამბუკის ფიცრები",
  "block.minecraft.bamboo_pressure_plate": "ბამბუკის საჭერი ფირფიტა",
  "block.minecraft.bamboo_sapling": "ბამბუკის ყლორტი",
  "block.minecraft.bamboo_shelf": "ბამბუკის თარო",
  "block.minecraft.bamboo_sign": "ბამბუკის აბრა",
  "block.minecraft.bamboo_slab": "ბამბუკის ფილა",
  "block.minecraft.bamboo_stairs": "ბამბუკის საფეხურები",
  "block.minecraft.bamboo_trapdoor": "ბამბუკის სარკმელი",
  "block.minecraft.bamboo_wall_hanging_sign": "ბამბუკის კედლის საკიდი აბრა",
  "block.minecraft.bamboo_wall_sign": "ბამბუკის კედლის აბრა",
  "block.minecraft.banner.base.black": "სრულიად შავი ველი",
  "block.minecraft.banner.base.blue": "სრულიად ლურჯი ველი",
  "block.minecraft.banner.base.brown": "სრულიად ყავისფერი ველი",
  "block.minecraft.banner.base.cyan": "სრულიად ფირუზისფერი ველი",
  "block.minecraft.banner.base.gray": "სრულიად ნაცრისფერი ველი",
  "block.minecraft.banner.base.green": "სრულიად მწვანე ველი",
  "block.minecraft.banner.base.light_blue": "სრულიად ცისფერი ველი",
  "block.minecraft.banner.base.light_gray": "სრულიად ღია ნაცრისფერი ველი",
  "block.minecraft.banner.base.lime": "სრულიად სალათისფერი ველი",
  "block.minecraft.banner.base.magenta": "სრულიად იასამნისფერი ველი",
  "block.minecraft.banner.base.orange": "სრულიად ნარინჯისფერი ველი",
  "block.minecraft.banner.base.pink": "სრულიად ვარდისფერი ველი",
  "block.minecraft.banner.base.purple": "სრულიად იისფერი ველი",
  "block.minecraft.banner.base.red": "სრულიად წითელი ველი",
  "block.minecraft.banner.base.white": "სრულიად თეთრი ველი",
  "block.minecraft.banner.base.yellow": "სრულიად ყვითელი ველი",
  "block.minecraft.banner.border.black": "შავი ჩარჩო",
  "block.minecraft.banner.border.blue": "ლურჯი ჩარჩო",
  "block.minecraft.banner.border.brown": "ყავისფერი ჩარჩო",
  "block.minecraft.banner.border.cyan": "ფირუზისფერი ჩარჩო",
  "block.minecraft.banner.border.gray": "ნაცრისფერი ჩარჩო",
  "block.minecraft.banner.border.green": "მწვანე ჩარჩო",
  "block.minecraft.banner.border.light_blue": "ცისფერი ჩარჩო",
  "block.minecraft.banner.border.light_gray": "ღია ნაცრისფერი ჩარჩო",
  "block.minecraft.banner.border.lime": "სალათისფერი ჩარჩო",
  "block.minecraft.banner.border.magenta": "იასამნისფერი ჩარჩო",
  "block.minecraft.banner.border.orange": "ნარინჯისფერი ჩარჩო",
  "block.minecraft.banner.border.pink": "ვარდისფერი ჩარჩო",
  "block.minecraft.banner.border.purple": "იისფერი ჩარჩო",
  "block.minecraft.banner.border.red": "წითელი ჩარჩო",
  "block.minecraft.banner.border.white": "თეთრი ჩარჩო",
  "block.minecraft.banner.border.yellow": "ყვითელი ჩარჩო",
  "block.minecraft.banner.bricks.black": "შავი აგურები",
  "block.minecraft.banner.bricks.blue": "ლურჯი აგურები",
  "block.minecraft.banner.bricks.brown": "ყავისფერი აგურები",
  "block.minecraft.banner.bricks.cyan": "ფირუზისფერი აგურები",
  "block.minecraft.banner.bricks.gray": "ნაცრისფერი აგურები",
  "block.minecraft.banner.bricks.green": "მწვანე აგურები",
  "block.minecraft.banner.bricks.light_blue": "ცისფერი აგურები",
  "block.minecraft.banner.bricks.light_gray": "ღია ნაცრისფერი აგურები",
  "block.minecraft.banner.bricks.lime": "სალათისფერი აგურები",
  "block.minecraft.banner.bricks.magenta": "იასამნისფერი აგურები",
  "block.minecraft.banner.bricks.orange": "ნარინჯისფერი აგურები",
  "block.minecraft.banner.bricks.pink": "ვარდისფერი აგურები",
  "block.minecraft.banner.bricks.purple": "იისფერი აგურები",
  "block.minecraft.banner.bricks.red": "წითელი აგურები",
  "block.minecraft.banner.bricks.white": "თეთრი აგურები",
  "block.minecraft.banner.bricks.yellow": "ყვითელი აგურები",
  "block.minecraft.banner.circle.black": "შავი წრე",
  "block.minecraft.banner.circle.blue": "ლურჯი წრე",
  "block.minecraft.banner.circle.brown": "ყავისფერი წრე",
  "block.minecraft.banner.circle.cyan": "ფირუზისფერი წრე",
  "block.minecraft.banner.circle.gray": "ნაცრისფერი წრე",
  "block.minecraft.banner.circle.green": "მწვანე წრე",
  "block.minecraft.banner.circle.light_blue": "ცისფერი წრე",
  "block.minecraft.banner.circle.light_gray": "ღია ნაცრისფერი წრე",
  "block.minecraft.banner.circle.lime": "სალათისფერი წრე",
  "block.minecraft.banner.circle.magenta": "იასამნისფერი წრე",
  "block.minecraft.banner.circle.orange": "ნარინჯისფერი წრე",
  "block.minecraft.banner.circle.pink": "ვარდისფერი წრე",
  "block.minecraft.banner.circle.purple": "იისფერი წრე",
  "block.minecraft.banner.circle.red": "წითელი წრე",
  "block.minecraft.banner.circle.white": "თეთრი წრე",
  "block.minecraft.banner.circle.yellow": "ყვითელი წრე",
  "block.minecraft.banner.creeper.black": "შავი კრიპერის სახე",
  "block.minecraft.banner.creeper.blue": "ლურჯი კრიპერის სახე",
  "block.minecraft.banner.creeper.brown": "ყავისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.cyan": "ფირუზისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.gray": "ნაცრისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.green": "მწვანე კრიპერის სახე",
  "block.minecraft.banner.creeper.light_blue": "ცისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.light_gray": "ღია ნაცრისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.lime": "სალათისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.magenta": "იასამნისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.orange": "ნარინჯისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.pink": "ვარდისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.purple": "იისფერი კრიპერის სახე",
  "block.minecraft.banner.creeper.red": "წითელი კრიპერის სახე",
  "block.minecraft.banner.creeper.white": "თეთრი კრიპერის სახე",
  "block.minecraft.banner.creeper.yellow": "ყვითელი კრიპერის სახე",
  "block.minecraft.banner.cross.black": "შავი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.blue": "ლურჯი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.brown": "ყავისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.cyan": "ფირუზისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.gray": "ნაცრისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.green": "მწვანე დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.light_blue": "ცისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.light_gray": "ღია ნაცრისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.lime": "სალათისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.magenta": "იასამნისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.orange": "ნარინჯისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.pink": "ვარდისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.purple": "იისფერი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.red": "წითელი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.white": "თეთრი დიაგონალური ჯვარი",
  "block.minecraft.banner.cross.yellow": "ყვითელი დიაგონალური ჯვარი",
  "block.minecraft.banner.curly_border.black": "შავი დაკბილული არშია",
  "block.minecraft.banner.curly_border.blue": "ლურჯი დაკბილული არშია",
  "block.minecraft.banner.curly_border.brown": "ყავისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.cyan": "ფირუზისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.gray": "ნაცრისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.green": "მწვანე დაკბილული არშია",
  "block.minecraft.banner.curly_border.light_blue": "ცისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.light_gray": "ღია ნაცრისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.lime": "სალათისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.magenta": "იასამნისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.orange": "ნარინჯისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.pink": "ვარდისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.purple": "იისფერი დაკბილული არშია",
  "block.minecraft.banner.curly_border.red": "წითელი დაკბილული არშია",
  "block.minecraft.banner.curly_border.white": "თეთრი დაკბილული არშია",
  "block.minecraft.banner.curly_border.yellow": "ყვითელი დაკბილული არშია",
  "block.minecraft.banner.diagonal_left.black": "შავი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.blue": "ლურჯი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.brown": "ყავისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.cyan": "ფირუზისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.gray": "ნაცრისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.green": "მწვანე ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.light_blue": "ცისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.light_gray": "ღია ნაცრისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.lime": "სალათისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.magenta": "იასამნისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.orange": "ნარინჯისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.pink": "ვარდისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.purple": "იისფერი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.red": "წითელი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.white": "თეთრი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_left.yellow": "ყვითელი ზედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.black": "შავი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.blue": "ლურჯი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.brown": "ყავისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.cyan": "ფირუზისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.gray": "ნაცრისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.green": "მწვანე ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.light_blue": "ცისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.light_gray": "ღია ნაცრისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.lime": "სალათისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.magenta": "იასამნისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.orange": "ნარინჯისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.pink": "ვარდისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.purple": "იისფერი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.red": "წითელი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.white": "თეთრი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_right.yellow": "ყვითელი ზედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.black": "შავი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.blue": "ლურჯი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.brown": "ყავისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.cyan": "ფირუზისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.gray": "ნაცრისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.green": "მწვანე ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.light_blue": "ცისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.light_gray": "ღია ნაცრისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.lime": "სალათისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.magenta": "იასამნისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.orange": "ნარინჯისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.pink": "ვარდისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.purple": "იისფერი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.red": "წითელი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.white": "თეთრი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_left.yellow": "ყვითელი ქვედა მარცხენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.black": "შავი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.blue": "ლურჯი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.brown": "ყავისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.cyan": "ფირუზისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.gray": "ნაცრისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.green": "მწვანე ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.light_blue": "ცისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.light_gray": "ღია ნაცრისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.lime": "სალათისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.magenta": "იასამნისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.orange": "ნარინჯისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.pink": "ვარდისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.purple": "იისფერი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.red": "წითელი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.white": "თეთრი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.diagonal_up_right.yellow": "ყვითელი ქვედა მარჯვენა დიაგონალი",
  "block.minecraft.banner.flow.black": "შავი ნაკადი",
  "block.minecraft.banner.flow.blue": "ლურჯი ნაკადი",
  "block.minecraft.banner.flow.brown": "ყავისფერი ნაკადი",
  "block.minecraft.banner.flow.cyan": "ფირუზისფერი ნაკადი",
  "block.minecraft.banner.flow.gray": "ნაცრისფერი ნაკადი",
  "block.minecraft.banner.flow.green": "მწვანე ნაკადი",
  "block.minecraft.banner.flow.light_blue": "ცისფერი ნაკადი",
  "block.minecraft.banner.flow.light_gray": "ღია ნაცრისფერი ნაკადი",
  "block.minecraft.banner.flow.lime": "სალათისფერი ნაკადი",
  "block.minecraft.banner.flow.magenta": "იასამნისფერი ნაკადი",
  "block.minecraft.banner.flow.orange": "ნარინჯისფერი ნაკადი",
  "block.minecraft.banner.flow.pink": "ვარდისფერი ნაკადი",
  "block.minecraft.banner.flow.purple": "იისფერი ნაკადი",
  "block.minecraft.banner.flow.red": "წითელი ნაკადი",
  "block.minecraft.banner.flow.white": "თეთრი ნაკადი",
  "block.minecraft.banner.flow.yellow": "ყვითელი ნაკადი",
  "block.minecraft.banner.flower.black": "შავი ყვავილი",
  "block.minecraft.banner.flower.blue": "ლურჯი ყვავილი",
  "block.minecraft.banner.flower.brown": "ყავისფერი ყვავილი",
  "block.minecraft.banner.flower.cyan": "ფირუზისფერი ყვავილი",
  "block.minecraft.banner.flower.gray": "ნაცრისფერი ყვავილი",
  "block.minecraft.banner.flower.green": "მწვანე ყვავილი",
  "block.minecraft.banner.flower.light_blue": "ცისფერი ყვავილი",
  "block.minecraft.banner.flower.light_gray": "ღია ნაცრისფერი ყვავილი",
  "block.minecraft.banner.flower.lime": "სალათისფერი ყვავილი",
  "block.minecraft.banner.flower.magenta": "იასამნისფერი ყვავილი",
  "block.minecraft.banner.flower.orange": "ნარინჯისფერი ყვავილი",
  "block.minecraft.banner.flower.pink": "ვარდისფერი ყვავილი",
  "block.minecraft.banner.flower.purple": "იისფერი ყვავილი",
  "block.minecraft.banner.flower.red": "წითელი ყვავილი",
  "block.minecraft.banner.flower.white": "თეთრი ყვავილი",
  "block.minecraft.banner.flower.yellow": "ყვითელი ყვავილი",
  "block.minecraft.banner.globe.black": "შავი გლობუსი",
  "block.minecraft.banner.globe.blue": "ლურჯი გლობუსი",
  "block.minecraft.banner.globe.brown": "ყავისფერი გლობუსი",
  "block.minecraft.banner.globe.cyan": "ფირუზისფერი გლობუსი",
  "block.minecraft.banner.globe.gray": "ნაცრისფერი გლობუსი",
  "block.minecraft.banner.globe.green": "მწვანე გლობუსი",
  "block.minecraft.banner.globe.light_blue": "ცისფერი გლობუსი",
  "block.minecraft.banner.globe.light_gray": "ღია ნაცრისფერი გლობუსი",
  "block.minecraft.banner.globe.lime": "სალათისფერი გლობუსი",
  "block.minecraft.banner.globe.magenta": "იასამნისფერი გლობუსი",
  "block.minecraft.banner.globe.orange": "ნარინჯისფერი გლობუსი",
  "block.minecraft.banner.globe.pink": "ვარდისფერი გლობუსი",
  "block.minecraft.banner.globe.purple": "იისფერი გლობუსი",
  "block.minecraft.banner.globe.red": "წითელი გლობუსი",
  "block.minecraft.banner.globe.white": "თეთრი გლობუსი",
  "block.minecraft.banner.globe.yellow": "ყვითელი გლობუსი",
  "block.minecraft.banner.gradient.black": "შავი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.blue": "ლურჯი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.brown": "ყავისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.cyan": "ფირუზისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.gray": "ნაცრისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.green": "მწვანე ზედა გრადიენტი",
  "block.minecraft.banner.gradient.light_blue": "ცისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.light_gray": "ღია ნაცრისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.lime": "სალათისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.magenta": "იასამნისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.orange": "ნარინჯისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.pink": "ვარდისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.purple": "იისფერი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.red": "წითელი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.white": "თეთრი ზედა გრადიენტი",
  "block.minecraft.banner.gradient.yellow": "ყვითელი ზედა გრადიენტი",
  "block.minecraft.banner.gradient_up.black": "შავი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.blue": "ლურჯი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.brown": "ყავისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.cyan": "ფირუზისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.gray": "ნაცრისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.green": "მწვანე ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.light_blue": "ცისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.light_gray": "ღია ნაცრისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.lime": "სალათისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.magenta": "იასამნისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.orange": "ნარინჯისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.pink": "ვარდისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.purple": "იისფერი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.red": "წითელი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.white": "თეთრი ქვემო გრადიენტი",
  "block.minecraft.banner.gradient_up.yellow": "ყვითელი ქვემო გრადიენტი",
  "block.minecraft.banner.guster.black": "შავი ქარბორბალა",
  "block.minecraft.banner.guster.blue": "ლურჯი ქარბორბალა",
  "block.minecraft.banner.guster.brown": "ყავისფერი ქარბორბალა",
  "block.minecraft.banner.guster.cyan": "ფირუზისფერი ქარბორბალა",
  "block.minecraft.banner.guster.gray": "ნაცრისფერი ქარბორბალა",
  "block.minecraft.banner.guster.green": "მწვანე ქარბორბალა",
  "block.minecraft.banner.guster.light_blue": "ცისფერი ქარბორბალა",
  "block.minecraft.banner.guster.light_gray": "ღია ნაცრისფერი ქარბორბალა",
  "block.minecraft.banner.guster.lime": "სალათისფერი ქარბორბალა",
  "block.minecraft.banner.guster.magenta": "იასამნიფერი ქარბორბალა",
  "block.minecraft.banner.guster.orange": "ნარინჯისფერი ქარბორბალა",
  "block.minecraft.banner.guster.pink": "ვარდისფერი ქარბორბალა",
  "block.minecraft.banner.guster.purple": "იისფერი ქარბორბალა",
  "block.minecraft.banner.guster.red": "წითელი ქარბორბალა",
  "block.minecraft.banner.guster.white": "თეთრი ქარბორბალა",
  "block.minecraft.banner.guster.yellow": "ყვითელი ქარბორბალა",
  "block.minecraft.banner.half_horizontal.black": "შავი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.blue": "ლურჯი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.brown": "ყავისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.cyan": "ფირუზისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.gray": "ნაცრისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.green": "მწვანე ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.light_blue": "ცისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.light_gray": "ღია ნაცრისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.lime": "სალათისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.magenta": "იასამნისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.orange": "ნარინჯისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.pink": "ვარდისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.purple": "იისფერი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.red": "წითელი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.white": "თეთრი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal.yellow": "ყვითელი ზედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.black": "შავი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.blue": "ლურჯი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.brown": "ყავისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "ფირუზისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.gray": "ნაცრისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.green": "მწვანე ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "ცისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "ღია ნაცრისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.lime": "სალათისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "იასამნისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.orange": "ნარინჯისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.pink": "ვარდისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.purple": "იისფერი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.red": "წითელი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.white": "თეთრი ქვედა ნახევარი",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "ყვითელი ქვედა ნახევარი",
  "block.minecraft.banner.half_vertical.black": "შავი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.blue": "ლურჯი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.brown": "ყავისფერი  მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.cyan": "ფირუზისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.gray": "ნაცრისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.green": "მწვანე  მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.light_blue": "ცისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.light_gray": "ღია ნაცრისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.lime": "სალათიფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.magenta": "იასამნისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.orange": "ნარინჯისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.pink": "ვარდისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.purple": "იისფერი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.red": "წითელი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.white": "თეთრი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical.yellow": "ყვითელი მარცხენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.black": "შავი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.blue": "ლურჯი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.brown": "ყავისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.cyan": "ფირუზისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.gray": "ნაცრისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.green": "მწვანე მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.light_blue": "ცისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.light_gray": "ღია ნაცრისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.lime": "სალათისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.magenta": "იასამნისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.orange": "ნარინჯისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.pink": "ვარდისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.purple": "იისფერი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.red": "წითელი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.white": "თეთრი მარჯვენა ნახევარი",
  "block.minecraft.banner.half_vertical_right.yellow": "ყვითელი მარჯვენა ნახევარი",
  "block.minecraft.banner.mojang.black": "შავი რაღაც",
  "block.minecraft.banner.mojang.blue": "ლურჯი რაღაც",
  "block.minecraft.banner.mojang.brown": "ყავისფერი რაღაც",
  "block.minecraft.banner.mojang.cyan": "ფირუზისფერი რაღაც",
  "block.minecraft.banner.mojang.gray": "ნაცრისფერი რაღაც",
  "block.minecraft.banner.mojang.green": "მწვანე რაღაც",
  "block.minecraft.banner.mojang.light_blue": "ცისფერი რაღაც",
  "block.minecraft.banner.mojang.light_gray": "ღია ნაცრისფერი რაღაც",
  "block.minecraft.banner.mojang.lime": "სალათისფერი რაღაც",
  "block.minecraft.banner.mojang.magenta": "იასამნისფერი რაღაც",
  "block.minecraft.banner.mojang.orange": "ნარინჯისფერი რაღაც",
  "block.minecraft.banner.mojang.pink": "ვარდისფერი რაღაც",
  "block.minecraft.banner.mojang.purple": "იისფერი რაღაც",
  "block.minecraft.banner.mojang.red": "წითელი რაღაც",
  "block.minecraft.banner.mojang.white": "თეთრი რაღაც",
  "block.minecraft.banner.mojang.yellow": "ყვითელი რაღაც",
  "block.minecraft.banner.piglin.black": "შავი დინგი",
  "block.minecraft.banner.piglin.blue": "ლურჯი დინგი",
  "block.minecraft.banner.piglin.brown": "ყავისფერი დინგი",
  "block.minecraft.banner.piglin.cyan": "ფირუზისფერი დინგი",
  "block.minecraft.banner.piglin.gray": "ნაცრისფერი დინგი",
  "block.minecraft.banner.piglin.green": "მწვანე დინგი",
  "block.minecraft.banner.piglin.light_blue": "ცისფერი დინგი",
  "block.minecraft.banner.piglin.light_gray": "ღია ნაცრისფერი დინგი",
  "block.minecraft.banner.piglin.lime": "სალათისფერი დინგი",
  "block.minecraft.banner.piglin.magenta": "იასამნისფერი დინგი",
  "block.minecraft.banner.piglin.orange": "ნარინჯისფერი დინგი",
  "block.minecraft.banner.piglin.pink": "ვარდისფერი დინგი",
  "block.minecraft.banner.piglin.purple": "იისფერი დინგი",
  "block.minecraft.banner.piglin.red": "წითელი დინგი",
  "block.minecraft.banner.piglin.white": "თეთრი დინგი",
  "block.minecraft.banner.piglin.yellow": "ყვითელი დინგი",
  "block.minecraft.banner.rhombus.black": "შავი რომბი",
  "block.minecraft.banner.rhombus.blue": "ლურჯი რომბი",
  "block.minecraft.banner.rhombus.brown": "ყავისფერი რომბი",
  "block.minecraft.banner.rhombus.cyan": "ფირუზისფერი რომბი",
  "block.minecraft.banner.rhombus.gray": "ნაცრისფერი რომბი",
  "block.minecraft.banner.rhombus.green": "მწვანე რომბი",
  "block.minecraft.banner.rhombus.light_blue": "ცისფერი რომბი",
  "block.minecraft.banner.rhombus.light_gray": "ღია ნაცრისფერი რომბი",
  "block.minecraft.banner.rhombus.lime": "სალათისფერი რომბი",
  "block.minecraft.banner.rhombus.magenta": "იასამნისფერი რომბი",
  "block.minecraft.banner.rhombus.orange": "ნარინჯისფერი რომბი",
  "block.minecraft.banner.rhombus.pink": "ვარდისფერი რომბი",
  "block.minecraft.banner.rhombus.purple": "იისფერი რომბი",
  "block.minecraft.banner.rhombus.red": "წითელი რომბი",
  "block.minecraft.banner.rhombus.white": "თეთრი რომბი",
  "block.minecraft.banner.rhombus.yellow": "ყვითელი რომბი",
  "block.minecraft.banner.skull.black": "შავი თავის ქალა",
  "block.minecraft.banner.skull.blue": "ლურჯი თავის ქალა",
  "block.minecraft.banner.skull.brown": "ყავისფერი თავის ქალა",
  "block.minecraft.banner.skull.cyan": "ფირუზისფერი თავის ქალა",
  "block.minecraft.banner.skull.gray": "ნაცრისფერი თავის ქალა",
  "block.minecraft.banner.skull.green": "მწვანე თავის ქალა",
  "block.minecraft.banner.skull.light_blue": "ცისფერი თავის ქალა",
  "block.minecraft.banner.skull.light_gray": "ღია ნაცრისფერი თავის ქალა",
  "block.minecraft.banner.skull.lime": "სალათისფერი თავის ქალა",
  "block.minecraft.banner.skull.magenta": "იასამნისფერი თავის ქალა",
  "block.minecraft.banner.skull.orange": "ნარინჯისფერი თავის ქალა",
  "block.minecraft.banner.skull.pink": "ვარდისფერი თავის ქალა",
  "block.minecraft.banner.skull.purple": "იისფერი თავის ქალა",
  "block.minecraft.banner.skull.red": "წითელი თავის ქალა",
  "block.minecraft.banner.skull.white": "თეთრი თავის ქალა",
  "block.minecraft.banner.skull.yellow": "ყვითელი თავის ქალა",
  "block.minecraft.banner.small_stripes.black": "შავი ზოლები",
  "block.minecraft.banner.small_stripes.blue": "ლურჯი ზოლები",
  "block.minecraft.banner.small_stripes.brown": "ყავისფერი ზოლები",
  "block.minecraft.banner.small_stripes.cyan": "ფირუზისფერი ზოლები",
  "block.minecraft.banner.small_stripes.gray": "ნაცრისფერი ზოლები",
  "block.minecraft.banner.small_stripes.green": "მწვანე ზოლები",
  "block.minecraft.banner.small_stripes.light_blue": "ცისფერი ზოლები",
  "block.minecraft.banner.small_stripes.light_gray": "ღია ნაცრისფერი ზოლები",
  "block.minecraft.banner.small_stripes.lime": "სალათისფერი ზოლები",
  "block.minecraft.banner.small_stripes.magenta": "იასამნისფერი ზოლები",
  "block.minecraft.banner.small_stripes.orange": "ნარინჯისფერი ზოლები",
  "block.minecraft.banner.small_stripes.pink": "ვარდისფერი ზოლები",
  "block.minecraft.banner.small_stripes.purple": "იისფერი ზოლები",
  "block.minecraft.banner.small_stripes.red": "წითელი ზოლები",
  "block.minecraft.banner.small_stripes.white": "თეთრი ზოლები",
  "block.minecraft.banner.small_stripes.yellow": "ყვითელი ზოლები",
  "block.minecraft.banner.square_bottom_left.black": "შავი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.blue": "ლურჯი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.brown": "ყავისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.cyan": "ფირუზისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.gray": "ნაცრისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.green": "მწვანე ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.light_blue": "ცისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.light_gray": "ღია ნაცრისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.lime": "სალათისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.magenta": "იასამნისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.orange": "ნარინჯისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.pink": "ვარდისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.purple": "იისფერი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.red": "წითელი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.white": "თეთრი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_left.yellow": "ყვითელი ქვედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.black": "შავი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.blue": "ლურჯი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.brown": "ყავისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.cyan": "ფირუზისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.gray": "ნაცრისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.green": "მწვანე ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.light_blue": "ცისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.light_gray": "ღია ნაცრისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.lime": "სალათისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.magenta": "იასამნისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.orange": "ნარინჯისფერი მარცხენა ქვედა კვადრატი",
  "block.minecraft.banner.square_bottom_right.pink": "ვარდისფერი მარცხენა ქვედა კვადრატი",
  "block.minecraft.banner.square_bottom_right.purple": "იისფერი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.red": "წითელი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.white": "თეთრი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_bottom_right.yellow": "ყვითელი ქვედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_left.black": "შავი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.blue": "ლურჯი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.brown": "ყავისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.cyan": "ფირუზისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.gray": "ნაცრისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.green": "მწვანე ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.light_blue": "ცისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.light_gray": "ღია ნაცრისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.lime": "სალათისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.magenta": "იასამნისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.orange": "ნარინჯისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.pink": "ვარდისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.purple": "იისფერი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.red": "წითელი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.white": "თეთრი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_left.yellow": "ყვითელი ზედა მარცხენა მეოთხედი",
  "block.minecraft.banner.square_top_right.black": "შავი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.blue": "ლურჯი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.brown": "ყავისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.cyan": "ფირუზისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.gray": "ნაცრისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.green": "მწვანე ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.light_blue": "ცისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.light_gray": "ღია ნაცრისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.lime": "სალათისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.magenta": "იასამნისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.orange": "ნარინჯისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.pink": "ვარდისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.purple": "იისფერი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.red": "წითელი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.white": "თეთრი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.square_top_right.yellow": "ყვითელი ზედა მარჯვენა მეოთხედი",
  "block.minecraft.banner.straight_cross.black": "შავი ჯვარი",
  "block.minecraft.banner.straight_cross.blue": "ლურჯი ჯვარი",
  "block.minecraft.banner.straight_cross.brown": "ყავისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.cyan": "ფირუზისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.gray": "ნაცრისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.green": "მწვანე ჯვარი",
  "block.minecraft.banner.straight_cross.light_blue": "ცისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.light_gray": "ღია ნაცრისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.lime": "სალათისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.magenta": "იასამნისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.orange": "ნარინჯისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.pink": "ვარდისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.purple": "იისფერი ჯვარი",
  "block.minecraft.banner.straight_cross.red": "წითელი ჯვარი",
  "block.minecraft.banner.straight_cross.white": "თეთრი ჯვარი",
  "block.minecraft.banner.straight_cross.yellow": "ყვითელი ჯვარი",
  "block.minecraft.banner.stripe_bottom.black": "შავი ძირი",
  "block.minecraft.banner.stripe_bottom.blue": "ლურჯი ძირი",
  "block.minecraft.banner.stripe_bottom.brown": "ყავისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.cyan": "ფირუზისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.gray": "ნაცრისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.green": "მწვანე ძირი",
  "block.minecraft.banner.stripe_bottom.light_blue": "ცისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.light_gray": "ღია ნაცრისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.lime": "სალათისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.magenta": "იასამნისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.orange": "ნარინჯისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.pink": "ვარდისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.purple": "იისფერი ძირი",
  "block.minecraft.banner.stripe_bottom.red": "წითელი ძირი",
  "block.minecraft.banner.stripe_bottom.white": "თეთრი ძირი",
  "block.minecraft.banner.stripe_bottom.yellow": "ყვითელი ძირი",
  "block.minecraft.banner.stripe_center.black": "შავი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.blue": "ლურჯი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.brown": "ყავისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.cyan": "ფირუზისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.gray": "ნაცრისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.green": "მწვანე შვეული ზოლი",
  "block.minecraft.banner.stripe_center.light_blue": "ცისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.light_gray": "ღია ნაცრისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.lime": "სალათისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.magenta": "იასამნისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.orange": "ნარინჯისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.pink": "ვარდისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.purple": "იისფერი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.red": "წითელი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.white": "თეთრი შვეული ზოლი",
  "block.minecraft.banner.stripe_center.yellow": "ყვითელი შვეული ზოლი",
  "block.minecraft.banner.stripe_downleft.black": "შავი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.blue": "ლურჯი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.brown": "ყავისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.cyan": "ფირუზისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.gray": "ნაცრისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.green": "მწვანე მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.light_blue": "ცისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.light_gray": "ღია ნაცრისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.lime": "სალათისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.magenta": "იასამნისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.orange": "ნარინჯისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.pink": "ვარდისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.purple": "იისფერი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.red": "წითელი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.white": "თეთრი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downleft.yellow": "ყვითელი მარცხნივ დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.black": "შავი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.blue": "ლურჯი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.brown": "ყავისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.cyan": "ფირუზისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.gray": "ნაცრისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.green": "მწვანე დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.light_blue": "ცისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.light_gray": "ღია ნაცრისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.lime": "სალათისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.magenta": "იასამნისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.orange": "ნარინჯისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.pink": "ვარდისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.purple": "იისფერი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.red": "წითელი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.white": "თეთრი დახრილი ზოლი",
  "block.minecraft.banner.stripe_downright.yellow": "ყვითელი დახრილი ზოლი",
  "block.minecraft.banner.stripe_left.black": "შავი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.blue": "ლურჯი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.brown": "ყავისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.cyan": "ცისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.gray": "ნაცრისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.green": "მწვანე მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.light_blue": "ღია-ლურჯი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.light_gray": "ღია-ნაცრისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.lime": "სალათისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.magenta": "იისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.orange": "ნარინჯისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.pink": "ვარდისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.purple": "ალისფერი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.red": "წითელი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.white": "თეთრი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_left.yellow": "ყვითელი მარჯვენა ზოლი",
  "block.minecraft.banner.stripe_middle.black": "შავი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.blue": "ლურჯი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.brown": "ყავისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.cyan": "ცისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.gray": "ნაცრისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.green": "მწვანე ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.light_blue": "ღია-ლურჯი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.light_gray": "ღია-ნაცრისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.lime": "სალათისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.magenta": "იისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.orange": "ნარინჯისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.pink": "ვარდისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.purple": "იისფერი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.red": "წითელი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.white": "თეთრი ფართო ზოლი",
  "block.minecraft.banner.stripe_middle.yellow": "ყვითელი ფართო ზოლი",
  "block.minecraft.banner.stripe_right.black": "შავი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.blue": "ლურჯი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.brown": "ყავისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.cyan": "ცისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.gray": "ნაცრისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.green": "მწვანე მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.light_blue": "ღია-ლურჯი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.light_gray": "ღია-ნაცრისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.lime": "სალათისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.magenta": "იისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.orange": "ნარინჯისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.pink": "ვარდისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.purple": "იისფერი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.red": "წითელი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.white": "თეთრი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_right.yellow": "ყვითელი მარცხენა ზოლი",
  "block.minecraft.banner.stripe_top.black": "შავი თავი",
  "block.minecraft.banner.stripe_top.blue": "ლურჯი თავი",
  "block.minecraft.banner.stripe_top.brown": "ყავისფერი თავი",
  "block.minecraft.banner.stripe_top.cyan": "ფირუზისფერი თავი",
  "block.minecraft.banner.stripe_top.gray": "ნაცრისფერი თავი",
  "block.minecraft.banner.stripe_top.green": "მწვანე თავი",
  "block.minecraft.banner.stripe_top.light_blue": "ცისფერი თავი",
  "block.minecraft.banner.stripe_top.light_gray": "ღია ნაცრისფერი თავი",
  "block.minecraft.banner.stripe_top.lime": "სალათისფერი თავი",
  "block.minecraft.banner.stripe_top.magenta": "იასამნისფერი თავი",
  "block.minecraft.banner.stripe_top.orange": "ნარინჯისფერი თავი",
  "block.minecraft.banner.stripe_top.pink": "ვარდისფერი თავი",
  "block.minecraft.banner.stripe_top.purple": "იისფერი თავი",
  "block.minecraft.banner.stripe_top.red": "წითელი თავი",
  "block.minecraft.banner.stripe_top.white": "თეთრი თავი",
  "block.minecraft.banner.stripe_top.yellow": "ყვითელი თავი",
  "block.minecraft.banner.triangle_bottom.black": "შავი შევრონი",
  "block.minecraft.banner.triangle_bottom.blue": "ლურჯი შევრონი",
  "block.minecraft.banner.triangle_bottom.brown": "ყავისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.cyan": "ცისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.gray": "ნაცრისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.green": "მწვანე შევრონი",
  "block.minecraft.banner.triangle_bottom.light_blue": "ღია-ლურჯი შევრონი",
  "block.minecraft.banner.triangle_bottom.light_gray": "ღია-ნაცრისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.lime": "სალათისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.magenta": "იისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.orange": "ნარინჯისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.pink": "ვარდისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.purple": "ალისფერი შევრონი",
  "block.minecraft.banner.triangle_bottom.red": "წითელი შევრონი",
  "block.minecraft.banner.triangle_bottom.white": "თეთრი შევრონი",
  "block.minecraft.banner.triangle_bottom.yellow": "ყვითელი შევრონი",
  "block.minecraft.banner.triangle_top.black": "შავი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.blue": "ლურჯი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.brown": "ყავისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.cyan": "ცისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.gray": "ნაცრისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.green": "მწვანე გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.light_blue": "ღია-ლურჯი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.light_gray": "ღია-ნაცრისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.lime": "სალათისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.magenta": "იისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.orange": "ნარინჯისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.pink": "ვარდისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.purple": "ალისფერი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.red": "წითელი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.white": "თეთრი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangle_top.yellow": "ყვითელი გადმობრუნებული შევრონი",
  "block.minecraft.banner.triangles_bottom.black": "შავი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.blue": "ლურჯი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.brown": "ყავისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.cyan": "ფირუზისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.gray": "ნაცრისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.green": "მწვანე ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.light_blue": "ცისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.light_gray": "ღია ნაცრისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.lime": "სალათისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.magenta": "იასამნისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.orange": "ნარინჯისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.pink": "ვარდისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.purple": "იისფერი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.red": "წითელი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.white": "თეთრი ქვედა კბილანები",
  "block.minecraft.banner.triangles_bottom.yellow": "ყვითელი ქვედა კბილანები",
  "block.minecraft.banner.triangles_top.black": "შავი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.blue": "ლურჯი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.brown": "ყავისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.cyan": "ფირუზისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.gray": "ნაცრისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.green": "მწვანე ზედა კბილანები",
  "block.minecraft.banner.triangles_top.light_blue": "ცისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.light_gray": "ღია ნაცრისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.lime": "სალათისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.magenta": "იასამნისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.orange": "ნარინჯისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.pink": "ვარდისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.purple": "იისფერი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.red": "წითელი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.white": "თეთრი ზედა კბილანები",
  "block.minecraft.banner.triangles_top.yellow": "ყვითელი ზედა კბილანები",
  "block.minecraft.barrel": "კასრი",
  "block.minecraft.barrier": "ბარიერი",
  "block.minecraft.basalt": "ბაზალტი",
  "block.minecraft.beacon": "შუქურა",
  "block.minecraft.beacon.primary": "ძირითადი ძალა",
  "block.minecraft.beacon.secondary": "მეორადი ძალა",
  "block.minecraft.bed.no_sleep": "ძილი შეიძლება, მოხლოდ ღამე ან ჭექა-ქუხილის დროს",
  "block.minecraft.bed.not_safe": "ახლა ვერ დაიძინებთ; ახლოს მონსტრებია",
  "block.minecraft.bed.obstructed": "ეს საწოლი დაბრკოლებულია",
  "block.minecraft.bed.occupied": "ეს საწოლი დაკავებულია",
  "block.minecraft.bed.too_far_away": "ახლა ვერ დაიძინებთ; საწოლი ძაან შორსაა",
  "block.minecraft.bedrock": "საძირკვლო ქვა",
  "block.minecraft.bee_nest": "ფუტკრის ბუდე",
  "block.minecraft.beehive": "სკა",
  "block.minecraft.beetroots": "ჭარხლები",
  "block.minecraft.bell": "ზარი",
  "block.minecraft.big_dripleaf": "დიდი წვეთფოთოლა",
  "block.minecraft.big_dripleaf_stem": "დიდი წვეთფოთოლას ღერო",
  "block.minecraft.birch_button": "არყის ღილაკი",
  "block.minecraft.birch_door": "არყის კარი",
  "block.minecraft.birch_fence": "არყის ღობე",
  "block.minecraft.birch_fence_gate": "არყის ჭიშკარი",
  "block.minecraft.birch_hanging_sign": "არყის საკიდი აბრა",
  "block.minecraft.birch_leaves": "არყის ფოთლები",
  "block.minecraft.birch_log": "არყის მორი",
  "block.minecraft.birch_planks": "არყის ფიცრები",
  "block.minecraft.birch_pressure_plate": "არყის საჭერი ფირფიტა",
  "block.minecraft.birch_sapling": "არყის ნერგი",
  "block.minecraft.birch_shelf": "არყის თარო",
  "block.minecraft.birch_sign": "არყის აბრა",
  "block.minecraft.birch_slab": "არყის ფილა",
  "block.minecraft.birch_stairs": "არყის საფეხურები",
  "block.minecraft.birch_trapdoor": "არყის სარკმელი",
  "block.minecraft.birch_wall_hanging_sign": "არყის კედლის საკიდი აბრა",
  "block.minecraft.birch_wall_sign": "არყის კედლის აბრა",
  "block.minecraft.birch_wood": "არყის მერქანი",
  "block.minecraft.black_banner": "შავი დროშა",
  "block.minecraft.black_bed": "შავი საწოლი",
  "block.minecraft.black_candle": "შავი სანთელი",
  "block.minecraft.black_candle_cake": "ტორტი შავი სანთლით",
  "block.minecraft.black_carpet": "შავი ხალიჩა",
  "block.minecraft.black_concrete": "შავი ბეტონი",
  "block.minecraft.black_concrete_powder": "შავი ცემენტი",
  "block.minecraft.black_glazed_terracotta": "შავი მოჭიქული ტერაკოტა",
  "block.minecraft.black_shulker_box": "შავი შალკერ-ყუთი",
  "block.minecraft.black_stained_glass": "შავი შუშა",
  "block.minecraft.black_stained_glass_pane": "შავი მინა",
  "block.minecraft.black_terracotta": "შავი ტერაკოტა",
  "block.minecraft.black_wool": "შავი მატყლი",
  "block.minecraft.blackstone": "შავქვა",
  "block.minecraft.blackstone_slab": "შავქვის ფილა",
  "block.minecraft.blackstone_stairs": "შავქვის საფეხურები",
  "block.minecraft.blackstone_wall": "შავქვის ზღუდე",
  "block.minecraft.blast_furnace": "ბრძმედი",
  "block.minecraft.blue_banner": "ლურჯი დროშა",
  "block.minecraft.blue_bed": "ლურჯი საწოლი",
  "block.minecraft.blue_candle": "ლურჯი სანთელი",
  "block.minecraft.blue_candle_cake": "ტორტი ლურჯი სანთლით",
  "block.minecraft.blue_carpet": "ლურჯი ხალიჩა",
  "block.minecraft.blue_concrete": "ლურჯი ბეტონი",
  "block.minecraft.blue_concrete_powder": "ლურჯი ცემენტი",
  "block.minecraft.blue_glazed_terracotta": "ლურჯი მოჭიქული ტერაკოტა",
  "block.minecraft.blue_ice": "ლურჯი ყინული",
  "block.minecraft.blue_orchid": "ლურჯი ორქიდეა",
  "block.minecraft.blue_shulker_box": "ლურჯი შალკერ-ყუთი",
  "block.minecraft.blue_stained_glass": "ლურჯი შუშა",
  "block.minecraft.blue_stained_glass_pane": "ლურჯი მინა",
  "block.minecraft.blue_terracotta": "ლურჯი ტერაკოტა",
  "block.minecraft.blue_wool": "ლურჯი მატყლი",
  "block.minecraft.bone_block": "ძვლის ბლოკი",
  "block.minecraft.bookshelf": "წიგნების თარო",
  "block.minecraft.brain_coral": "ტვინის მარჯანი",
  "block.minecraft.brain_coral_block": "ტვინის მარჯნის ბლოკი",
  "block.minecraft.brain_coral_fan": "ტვინის მარაოსებრი მარჯანი",
  "block.minecraft.brain_coral_wall_fan": "ტვინის მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.brewing_stand": "ხსნარსახარში",
  "block.minecraft.brick_slab": "აგურის ფილა",
  "block.minecraft.brick_stairs": "აგურის საფეხურები",
  "block.minecraft.brick_wall": "აგურის ზღუდე",
  "block.minecraft.bricks": "აგურები",
  "block.minecraft.brown_banner": "ყავისფერი დროშა",
  "block.minecraft.brown_bed": "ყავისფერი საწოლი",
  "block.minecraft.brown_candle": "ყავისფერი სანთელი",
  "block.minecraft.brown_candle_cake": "ტორტი ყავისფერი სანთლით",
  "block.minecraft.brown_carpet": "ყავისფერი ხალიჩა",
  "block.minecraft.brown_concrete": "ყავისფერი ბეტონი",
  "block.minecraft.brown_concrete_powder": "ყავისფერი ცემენტი",
  "block.minecraft.brown_glazed_terracotta": "ყავისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.brown_mushroom": "ყავისფერი სოკო",
  "block.minecraft.brown_mushroom_block": "ყავისფერი სოკოს ბლოკი",
  "block.minecraft.brown_shulker_box": "ყავისფერი შალკერ-ყუთი",
  "block.minecraft.brown_stained_glass": "ყავისფერი შუშა",
  "block.minecraft.brown_stained_glass_pane": "ყავისფერი მინა",
  "block.minecraft.brown_terracotta": "ყავისფერი ტერაკოტა",
  "block.minecraft.brown_wool": "ყავისფერი მატყლი",
  "block.minecraft.bubble_column": "ბუშტულათა სვეტი",
  "block.minecraft.bubble_coral": "ბუშტოვანი მარჯანი",
  "block.minecraft.bubble_coral_block": "ბუშტოვანი მარჯნის ბლოკი",
  "block.minecraft.bubble_coral_fan": "ბუშტოვანი მარაოსებრი მარჯანი",
  "block.minecraft.bubble_coral_wall_fan": "ბუშტოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.budding_amethyst": "აყვავებული ამეთვისტო",
  "block.minecraft.bush": "ბუჩქი",
  "block.minecraft.cactus": "კაქტუსი",
  "block.minecraft.cactus_flower": "კაქტუსის ყვავილი",
  "block.minecraft.cake": "ტორტი",
  "block.minecraft.calcite": "კალციტი",
  "block.minecraft.calibrated_sculk_sensor": "კალიბრირებული სკალკ-სენსორი",
  "block.minecraft.campfire": "კოცონი",
  "block.minecraft.candle": "სანთელი",
  "block.minecraft.candle_cake": "ტორტი სანთლით",
  "block.minecraft.carrots": "სტაფილოები",
  "block.minecraft.cartography_table": "კარტოგრაფის მაგიდა",
  "block.minecraft.carved_pumpkin": "გამოჭრილი გოგრა",
  "block.minecraft.cauldron": "ქვაბი",
  "block.minecraft.cave_air": "გამოქვაბულის ჰაერი",
  "block.minecraft.cave_vines": "გამოქვაბულის სურო",
  "block.minecraft.cave_vines_plant": "გამოქვაბულის სუროს ღერო",
  "block.minecraft.chain": "ჯაჭვი",
  "block.minecraft.chain_command_block": "ჯაჭვური ბრძანების ბლოკი",
  "block.minecraft.cherry_button": "ალუბლის ღილაკი",
  "block.minecraft.cherry_door": "ალუბლის კარი",
  "block.minecraft.cherry_fence": "ალუბლის ღობე",
  "block.minecraft.cherry_fence_gate": "ალუბლის ჭიშკარი",
  "block.minecraft.cherry_hanging_sign": "ალუბლის საკიდი აბრა",
  "block.minecraft.cherry_leaves": "ალუბლის ფოთლები",
  "block.minecraft.cherry_log": "ალუბლის მორი",
  "block.minecraft.cherry_planks": "ალუბლის ფიცრები",
  "block.minecraft.cherry_pressure_plate": "ალუბლის საჭერი ფირფიტა",
  "block.minecraft.cherry_sapling": "ალუბლის ნერგი",
  "block.minecraft.cherry_shelf": "ალუბლის თარო",
  "block.minecraft.cherry_sign": "ალუბლის აბრა",
  "block.minecraft.cherry_slab": "ალუბლის ფილა",
  "block.minecraft.cherry_stairs": "ალუბლის საფეხურები",
  "block.minecraft.cherry_trapdoor": "ალუბლის სარკმელი",
  "block.minecraft.cherry_wall_hanging_sign": "ალუბლის კედლის საკიდი აბრა",
  "block.minecraft.cherry_wall_sign": "ალუბლის კედლის აბრა",
  "block.minecraft.cherry_wood": "ალუბლის მერქანი",
  "block.minecraft.chest": "სკივრი",
  "block.minecraft.chipped_anvil": "გაბზარული გრდემლი",
  "block.minecraft.chiseled_bookshelf": "მოჭრილი წიგნების თარო",
  "block.minecraft.chiseled_copper": "მოჩუქურთმებული სპილენძი",
  "block.minecraft.chiseled_deepslate": "მოჩუქურთმებული სიღრმის ფიქალი",
  "block.minecraft.chiseled_nether_bricks": "მოჩუქურთმებული ნეზერის აგურები",
  "block.minecraft.chiseled_polished_blackstone": "მოჩუქურთმებული შავქვა",
  "block.minecraft.chiseled_quartz_block": "მოჩუქურთმებული კვარცის ბლოკი",
  "block.minecraft.chiseled_red_sandstone": "მოჩუქურთმებული წითელი ქვიშაქვა",
  "block.minecraft.chiseled_resin_bricks": "მოჩუქურთმებული ფისის აგურები",
  "block.minecraft.chiseled_sandstone": "მოჩუქურთმებული ქვიშაქვა",
  "block.minecraft.chiseled_stone_bricks": "მოჩუქურთმებული ქვის აგურები",
  "block.minecraft.chiseled_tuff": "მოჩუქურთმებული ტუფი",
  "block.minecraft.chiseled_tuff_bricks": "მოჩუქურთმებული ტუფის აგურები",
  "block.minecraft.chorus_flower": "ქორუსის ყვავილი",
  "block.minecraft.chorus_plant": "ქორუსი",
  "block.minecraft.clay": "თიხა",
  "block.minecraft.closed_eyeblossom": "დახურული თვალყვავილა",
  "block.minecraft.coal_block": "ქვანახშირის ბლოკი",
  "block.minecraft.coal_ore": "ქვანახშირის მადანი",
  "block.minecraft.coarse_dirt": "ხრეშიანი მიწა",
  "block.minecraft.cobbled_deepslate": "მოკირწყლული სიღრმის ფიქალი",
  "block.minecraft.cobbled_deepslate_slab": "მოკირწყლული სიღრმის ფიქალის ფილა",
  "block.minecraft.cobbled_deepslate_stairs": "მოკირწყლული სიღრმის ფიქალის საფეხურები",
  "block.minecraft.cobbled_deepslate_wall": "მოკირწყლული სიღრმის ფიქალის ზღუდე",
  "block.minecraft.cobblestone": "რიყის ქვა",
  "block.minecraft.cobblestone_slab": "რიყის ქვის ფილა",
  "block.minecraft.cobblestone_stairs": "რიყის ქვის საფეხურები",
  "block.minecraft.cobblestone_wall": "რიყის ქვის ზღუდე",
  "block.minecraft.cobweb": "აბლაბუდა",
  "block.minecraft.cocoa": "კაკაო",
  "block.minecraft.command_block": "ბრძანების ბლოკი",
  "block.minecraft.comparator": "რედსტოუნის კომპარატორი",
  "block.minecraft.composter": "კომპოსტერი",
  "block.minecraft.conduit": "ზღვის ბირთვი",
  "block.minecraft.copper_bars": "სპილენძის გისოსები",
  "block.minecraft.copper_block": "სპილენძის ბლოკი",
  "block.minecraft.copper_bulb": "სპილენძის ნათურა",
  "block.minecraft.copper_chain": "სპილენძის ჯაჭვი",
  "block.minecraft.copper_chest": "სპილენძის სკივრი",
  "block.minecraft.copper_door": "სპილენძის კარი",
  "block.minecraft.copper_golem_statue": "სპილენძის გოლემის ქანდაკება",
  "block.minecraft.copper_grate": "სპილენძის ცხაურა",
  "block.minecraft.copper_lantern": "სპილენძის ლამპარი",
  "block.minecraft.copper_ore": "სპილენძის მადანი",
  "block.minecraft.copper_torch": "სპილენძის ჩირაღდანი",
  "block.minecraft.copper_trapdoor": "სპილენძის სარკმელი",
  "block.minecraft.copper_wall_torch": "სპილენძის კედლის ჩირაღდანი",
  "block.minecraft.cornflower": "ღიღილო",
  "block.minecraft.cracked_deepslate_bricks": "გაბზარული სიღრმის ფიქალის აგურები",
  "block.minecraft.cracked_deepslate_tiles": "გაბზარული სიღრმის ფიქალის ფილაქანი",
  "block.minecraft.cracked_nether_bricks": "გაბზარული ნეზერის აგურები",
  "block.minecraft.cracked_polished_blackstone_bricks": "გაბზარული გაპრიალებული შავქვის აგურები",
  "block.minecraft.cracked_stone_bricks": "გაბზარული ქვის აგურები",
  "block.minecraft.crafter": "ამწყობი",
  "block.minecraft.crafting_table": "დაზგა",
  "block.minecraft.creaking_heart": "გულჭრიალა",
  "block.minecraft.creeper_head": "კრიპერის თავი",
  "block.minecraft.creeper_wall_head": "კრიპერის კედლის თავი",
  "block.minecraft.crimson_button": "ჟოლოსფერი ღილაკი",
  "block.minecraft.crimson_door": "ჟოლოსფერი კარი",
  "block.minecraft.crimson_fence": "ჟოლოსფერი ღობე",
  "block.minecraft.crimson_fence_gate": "ჟოლოსფერი ჭიშკარი",
  "block.minecraft.crimson_fungus": "ჟოლოსფერი სოკო",
  "block.minecraft.crimson_hanging_sign": "ჟოლოსფერი საკიდი აბრა",
  "block.minecraft.crimson_hyphae": "ჟოლოსფერი ჰიფები",
  "block.minecraft.crimson_nylium": "ჟოლოსფერი ნილიუმი",
  "block.minecraft.crimson_planks": "ჟოლოსფერი ფიცრები",
  "block.minecraft.crimson_pressure_plate": "ჟოლოსფერი საჭერი ფირფიტა",
  "block.minecraft.crimson_roots": "ჟოლოსფერი ფესვები",
  "block.minecraft.crimson_shelf": "ჟოლოსფერი თარო",
  "block.minecraft.crimson_sign": "ჟოლოსფერი აბრა",
  "block.minecraft.crimson_slab": "ჟოლოსფერი ფილა",
  "block.minecraft.crimson_stairs": "ჟოლოსფერი საფეხურები",
  "block.minecraft.crimson_stem": "ჟოლოსფერი ღერო",
  "block.minecraft.crimson_trapdoor": "ჟოლოსფერი სარკმელი",
  "block.minecraft.crimson_wall_hanging_sign": "ჟოლოსფერი კედლის საკიდი აბრა",
  "block.minecraft.crimson_wall_sign": "ჟოლოსფერი კედლის აბრა",
  "block.minecraft.crying_obsidian": "მტირალი ობსიდიანი",
  "block.minecraft.cut_copper": "მოჭრილი სპილენძი",
  "block.minecraft.cut_copper_slab": "მოჭრილი სპილენძის ფილა",
  "block.minecraft.cut_copper_stairs": "მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.cut_red_sandstone": "მოჭრილი წითელი ქვიშაქვა",
  "block.minecraft.cut_red_sandstone_slab": "მოჭრილი წითელი ქვიშაქვის ფილა",
  "block.minecraft.cut_sandstone": "მოჭრილი ქვიშაქვა",
  "block.minecraft.cut_sandstone_slab": "მოჭრილი ქვიშაქვის ფილა",
  "block.minecraft.cyan_banner": "ფირუზისფერი დროშა",
  "block.minecraft.cyan_bed": "ფირუზისფერი საწოლი",
  "block.minecraft.cyan_candle": "ფირუზისფერი სანთელი",
  "block.minecraft.cyan_candle_cake": "ტორტი ფირუზისფერი სანთლით",
  "block.minecraft.cyan_carpet": "ფირუზისფერი ხალიჩა",
  "block.minecraft.cyan_concrete": "ფირუზისფერი ბეტონი",
  "block.minecraft.cyan_concrete_powder": "ფირუზისფერი ცემენტი",
  "block.minecraft.cyan_glazed_terracotta": "ფირუზისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.cyan_shulker_box": "ფირუზისფერი შალკერ-ყუთი",
  "block.minecraft.cyan_stained_glass": "ფირუზისფერი შუშა",
  "block.minecraft.cyan_stained_glass_pane": "ფირუზისფერი მინა",
  "block.minecraft.cyan_terracotta": "ფირუზისფერი ტერაკოტა",
  "block.minecraft.cyan_wool": "ფირუზისფერი მატყლი",
  "block.minecraft.damaged_anvil": "დაზიანებული გრდემლი",
  "block.minecraft.dandelion": "ბაბუაწვერა",
  "block.minecraft.dark_oak_button": "მუქი მუხის ღილაკი",
  "block.minecraft.dark_oak_door": "მუქი მუხის კარი",
  "block.minecraft.dark_oak_fence": "მუქი მუხის ღობე",
  "block.minecraft.dark_oak_fence_gate": "მუქი მუხის ჭიშკარი",
  "block.minecraft.dark_oak_hanging_sign": "მუქი მუხის საკიდი აბრა",
  "block.minecraft.dark_oak_leaves": "მუქი მუხის ფოთლები",
  "block.minecraft.dark_oak_log": "მუქი მუხის მორი",
  "block.minecraft.dark_oak_planks": "მუქი მუხის ფიცრები",
  "block.minecraft.dark_oak_pressure_plate": "მუქი მუხის საჭერი ფირფიტა",
  "block.minecraft.dark_oak_sapling": "მუქი მუხის ნერგი",
  "block.minecraft.dark_oak_shelf": "მუქი მუხის თარო",
  "block.minecraft.dark_oak_sign": "მუქი მუხის აბრა",
  "block.minecraft.dark_oak_slab": "მუქი მუხის ფილა",
  "block.minecraft.dark_oak_stairs": "მუქი მუხის საფეხურები",
  "block.minecraft.dark_oak_trapdoor": "მუქი მუხის სარკმელი",
  "block.minecraft.dark_oak_wall_hanging_sign": "მუქი მუხის კედლის საკიდი აბრა",
  "block.minecraft.dark_oak_wall_sign": "მუქი მუხის კედლის აბრა",
  "block.minecraft.dark_oak_wood": "მუქი მუხის მერქანი",
  "block.minecraft.dark_prismarine": "მუქი პრიზმარინი",
  "block.minecraft.dark_prismarine_slab": "მუქი პრიზმარინის ფილა",
  "block.minecraft.dark_prismarine_stairs": "მუქი პრიზმარინის საფეხურები",
  "block.minecraft.daylight_detector": "დღის სინათლის მსაზღვრელი",
  "block.minecraft.dead_brain_coral": "მკვდარი ტვინის მარჯანი",
  "block.minecraft.dead_brain_coral_block": "მკვდარი ტვინის მარჯნის ბლოკი",
  "block.minecraft.dead_brain_coral_fan": "მკვდარი ტვინის მარაოსებრი მარჯანი",
  "block.minecraft.dead_brain_coral_wall_fan": "მკვდარი ტვინის მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.dead_bubble_coral": "მკვდარი ბუშტოვანი მარჯანი",
  "block.minecraft.dead_bubble_coral_block": "მკვდარი ბუშტოვანი მარჯნის ბლოკი",
  "block.minecraft.dead_bubble_coral_fan": "მკვდარი ბუშტოვანი მარაოსებრი მარჯანი",
  "block.minecraft.dead_bubble_coral_wall_fan": "მკვდარი ბუშტოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.dead_bush": "გამხმარი ბუჩქი",
  "block.minecraft.dead_fire_coral": "მკვდარი ცეცხლოვანი მარჯანი",
  "block.minecraft.dead_fire_coral_block": "მკვდარი ცეცხლოვანი მარჯნის ბლოკი",
  "block.minecraft.dead_fire_coral_fan": "მკვდარი ცეცხლოვანი მარაოსებრი მარჯანი",
  "block.minecraft.dead_fire_coral_wall_fan": "მკვდარი ცეცხლოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.dead_horn_coral": "მკვდარი რქოვანი მარჯანი",
  "block.minecraft.dead_horn_coral_block": "მკვდარი რქოვანი მარჯნის ბლოკი",
  "block.minecraft.dead_horn_coral_fan": "მკვდარი რქოვანი მარაოსებრი მარჯანი",
  "block.minecraft.dead_horn_coral_wall_fan": "მკვდარი რქოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.dead_tube_coral": "მკვდარი მილაკოვანი მარჯანი",
  "block.minecraft.dead_tube_coral_block": "მკვდარი მილაკოვანი მარჯნის ბლოკი",
  "block.minecraft.dead_tube_coral_fan": "მკვდარი მილაკოვანი მარაოსებრი მარჯანი",
  "block.minecraft.dead_tube_coral_wall_fan": "მკვდარი მილაკოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.decorated_pot": "მორთული დოქი",
  "block.minecraft.deepslate": "სიღრმის ფიქალი",
  "block.minecraft.deepslate_brick_slab": "სიღრმის ფიქალის აგურის ფილა",
  "block.minecraft.deepslate_brick_stairs": "სიღრმის ფიქალის აგურის საფეხურები",
  "block.minecraft.deepslate_brick_wall": "სიღრმის ფიქალის აგურის ზღუდე",
  "block.minecraft.deepslate_bricks": "სიღრმის ფიქალის აგურები",
  "block.minecraft.deepslate_coal_ore": "ქვანახშირიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_copper_ore": "სპილენძიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_diamond_ore": "ალმასიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_emerald_ore": "ზურმუხტიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_gold_ore": "ოქროიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_iron_ore": "რკინიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_lapis_ore": "ლილაქვიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_redstone_ore": "რედსტოუნიანი სიღრმის ფიქალის მადანი",
  "block.minecraft.deepslate_tile_slab": "სიღრმის ფიქალის ფილაქანის ფილა",
  "block.minecraft.deepslate_tile_stairs": "სიღრმის ფიქალის ფილაქანის საფეხურები",
  "block.minecraft.deepslate_tile_wall": "სიღრმის ფიქალის ფილაქანის ზღუდე",
  "block.minecraft.deepslate_tiles": "სიღრმის ფიქალის ფილაქანი",
  "block.minecraft.detector_rail": "მგრძნობიარე რელსი",
  "block.minecraft.diamond_block": "ალმასის ბლოკი",
  "block.minecraft.diamond_ore": "ალმასის მადანი",
  "block.minecraft.diorite": "დიორიტი",
  "block.minecraft.diorite_slab": "დიორიტის ფილა",
  "block.minecraft.diorite_stairs": "დიორიტის საფეხურები",
  "block.minecraft.diorite_wall": "დიორიტის ზღუდე",
  "block.minecraft.dirt": "მიწა",
  "block.minecraft.dirt_path": "მიწის ბილიკი",
  "block.minecraft.dispenser": "გამტყორცნი",
  "block.minecraft.dragon_egg": "დრაკონის კვერცხი",
  "block.minecraft.dragon_head": "დრაკონის თავი",
  "block.minecraft.dragon_wall_head": "დრაკონის კედლის თავი",
  "block.minecraft.dried_ghast": "გამომშრალი გასტი",
  "block.minecraft.dried_kelp_block": "ხმელი ლამინარიის ბლოკი",
  "block.minecraft.dripstone_block": "წვეთოვანი ქვა",
  "block.minecraft.dropper": "დამყრელი",
  "block.minecraft.emerald_block": "ზურმუხტის ბლოკი",
  "block.minecraft.emerald_ore": "ზურმუხტის მადანი",
  "block.minecraft.enchanting_table": "მოჯადოების მაგიდა",
  "block.minecraft.end_gateway": "ენდის კარიბჭე",
  "block.minecraft.end_portal": "ენდის პორტალი",
  "block.minecraft.end_portal_frame": "ენდის პორტალის ჩარჩო",
  "block.minecraft.end_rod": "ენდის ღერძი",
  "block.minecraft.end_stone": "ენდქვა",
  "block.minecraft.end_stone_brick_slab": "ენდქვის აგურის ფილა",
  "block.minecraft.end_stone_brick_stairs": "ენდქვის აგურის საფეხურები",
  "block.minecraft.end_stone_brick_wall": "ენდქვის აგურის ზღუდე",
  "block.minecraft.end_stone_bricks": "ენდქვის აგურები",
  "block.minecraft.ender_chest": "ენდერ-სკივრი",
  "block.minecraft.exposed_chiseled_copper": "გამუქებული მოჩუქურთმებული სპილენძი",
  "block.minecraft.exposed_copper": "გამუქებული სპილენძი",
  "block.minecraft.exposed_copper_bars": "გამუქებული სპილენძის გისოსები",
  "block.minecraft.exposed_copper_bulb": "გამუქებული სპილენძის ნათურა",
  "block.minecraft.exposed_copper_chain": "გამუქებული სპილენძის ჯაჭვი",
  "block.minecraft.exposed_copper_chest": "გამუქებული სპილენძის სკივრი",
  "block.minecraft.exposed_copper_door": "გამუქებული სპილენძის კარი",
  "block.minecraft.exposed_copper_golem_statue": "გამუქებული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.exposed_copper_grate": "გამუქებული სპილენძის ცხაურა",
  "block.minecraft.exposed_copper_lantern": "გამუქებული სპილენძის ლამპარი",
  "block.minecraft.exposed_copper_trapdoor": "გამუქებული სპილენძის სარკმელი",
  "block.minecraft.exposed_cut_copper": "გამუქებული მოჭრილი სპილენძი",
  "block.minecraft.exposed_cut_copper_slab": "გამუქებული მოჭრილი სპილენძის ფილა",
  "block.minecraft.exposed_cut_copper_stairs": "გამუქებული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.exposed_lightning_rod": "გამუქებული მეხამრიდი",
  "block.minecraft.farmland": "მოხნული მიწა",
  "block.minecraft.fern": "გვიმრა",
  "block.minecraft.fire": "ცეცხლი",
  "block.minecraft.fire_coral": "ცეცხლოვანი მარჯანი",
  "block.minecraft.fire_coral_block": "ცეცხლოვანი მარჯნის ბლოკი",
  "block.minecraft.fire_coral_fan": "ცეცხლოვანი მარაოსებრი მარჯანი",
  "block.minecraft.fire_coral_wall_fan": "ცეცხლოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.firefly_bush": "ციცინათელებიანი ბუჩქი",
  "block.minecraft.fletching_table": "მშვილდოსნის მაგიდა",
  "block.minecraft.flower_pot": "ყვავილის ქოთანი",
  "block.minecraft.flowering_azalea": "აყვავებული აზალია",
  "block.minecraft.flowering_azalea_leaves": "აყვავებული აზალიას ფოთლები",
  "block.minecraft.frogspawn": "ბაყაყის ქვირითი",
  "block.minecraft.frosted_ice": "გაყინული ყინული",
  "block.minecraft.furnace": "ღუმელი",
  "block.minecraft.gilded_blackstone": "მოოქრული შავქვა",
  "block.minecraft.glass": "შუშა",
  "block.minecraft.glass_pane": "მინა",
  "block.minecraft.glow_lichen": "ნათობი ქარაგოზი",
  "block.minecraft.glowstone": "ნათობქვა",
  "block.minecraft.gold_block": "ოქროს ბლოკი",
  "block.minecraft.gold_ore": "ოქროს მადანი",
  "block.minecraft.golden_dandelion": "ოქროს ბაბუაწვერა",
  "block.minecraft.granite": "გრანიტი",
  "block.minecraft.granite_slab": "გრანიტის ფილა",
  "block.minecraft.granite_stairs": "გრანიტის საფეხურები",
  "block.minecraft.granite_wall": "გრანიტის ზღუდე",
  "block.minecraft.grass": "ბალახი",
  "block.minecraft.grass_block": "ბალახის ბლოკი",
  "block.minecraft.gravel": "ხრეში",
  "block.minecraft.gray_banner": "ნაცრისფერი დროშა",
  "block.minecraft.gray_bed": "ნაცრისფერი საწოლი",
  "block.minecraft.gray_candle": "ნაცრისფერი სანთელი",
  "block.minecraft.gray_candle_cake": "ტორტი ნაცრისფერი სანთლით",
  "block.minecraft.gray_carpet": "ნაცრისფერი ხალიჩა",
  "block.minecraft.gray_concrete": "ნაცრისფერი ბეტონი",
  "block.minecraft.gray_concrete_powder": "ნაცრისფერი ცემენტი",
  "block.minecraft.gray_glazed_terracotta": "ნაცრისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.gray_shulker_box": "ნაცრისფერი შალკერ-ყუთი",
  "block.minecraft.gray_stained_glass": "ნაცრისფერი შუშა",
  "block.minecraft.gray_stained_glass_pane": "ნაცრისფერი მინა",
  "block.minecraft.gray_terracotta": "ნაცრისფერი ტერაკოტა",
  "block.minecraft.gray_wool": "ნაცრისფერი მატყლი",
  "block.minecraft.green_banner": "მწვანე დროშა",
  "block.minecraft.green_bed": "მწვანე საწოლი",
  "block.minecraft.green_candle": "მწვანე სანთელი",
  "block.minecraft.green_candle_cake": "ტორტი მწვანე სანთლით",
  "block.minecraft.green_carpet": "მწვანე ხალიჩა",
  "block.minecraft.green_concrete": "მწვანე ბეტონი",
  "block.minecraft.green_concrete_powder": "მწვანე ცემენტი",
  "block.minecraft.green_glazed_terracotta": "მწვანე მოჭიქული ტერაკოტა",
  "block.minecraft.green_shulker_box": "მწვანე შალკერ-ყუთი",
  "block.minecraft.green_stained_glass": "მწვანე შუშა",
  "block.minecraft.green_stained_glass_pane": "მწვანე მინა",
  "block.minecraft.green_terracotta": "მწვანე ტერაკოტა",
  "block.minecraft.green_wool": "მწვანე მატყლი",
  "block.minecraft.grindstone": "სალესავი",
  "block.minecraft.hanging_roots": "ჩამოკიდული ფესვები",
  "block.minecraft.hay_block": "თივის შეკვრა",
  "block.minecraft.heavy_core": "მძიმე ბირთვი",
  "block.minecraft.heavy_weighted_pressure_plate": "მძიმე წონადობის საჭერი ფირფიტა",
  "block.minecraft.honey_block": "თაფლის ბლოკი",
  "block.minecraft.honeycomb_block": "ფიჭის ბლოკი",
  "block.minecraft.hopper": "ძაბრი",
  "block.minecraft.horn_coral": "რქოვანი მარჯანი",
  "block.minecraft.horn_coral_block": "რქოვანი მარჯნის ბლოკი",
  "block.minecraft.horn_coral_fan": "რქოვანი მარაოსებრი მარჯანი",
  "block.minecraft.horn_coral_wall_fan": "რქოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.ice": "ყინული",
  "block.minecraft.infested_chiseled_stone_bricks": "დაავადებული მოჩუქურთმებული ქვის აგურები",
  "block.minecraft.infested_cobblestone": "დაავადებული რიყის ქვა",
  "block.minecraft.infested_cracked_stone_bricks": "დაავადებული გაბზარული ქვის აგურები",
  "block.minecraft.infested_deepslate": "დაავადებული სიღრმის ფიქალი",
  "block.minecraft.infested_mossy_stone_bricks": "დაავადებული ხავსიანი ქვის აგურები",
  "block.minecraft.infested_stone": "დაავადებული ქვა",
  "block.minecraft.infested_stone_bricks": "დაავადებული ქვის აგურები",
  "block.minecraft.iron_bars": "რკინის გისოსები",
  "block.minecraft.iron_block": "რკინის ბლოკი",
  "block.minecraft.iron_chain": "რკინის ჯაჭვი",
  "block.minecraft.iron_door": "რკინის კარი",
  "block.minecraft.iron_ore": "რკინის მადანი",
  "block.minecraft.iron_trapdoor": "რკინის სარკმელი",
  "block.minecraft.jack_o_lantern": "მანათობელი გოგრა",
  "block.minecraft.jigsaw": "პაზლი",
  "block.minecraft.jukebox": "დამკვრელი",
  "block.minecraft.jungle_button": "ტროპიკული ხის ღილაკი",
  "block.minecraft.jungle_door": "ჯუნგლის კარი",
  "block.minecraft.jungle_fence": "ჯუნგლის ღობე",
  "block.minecraft.jungle_fence_gate": "ჯუნგლის ღობის ჭიშკარი",
  "block.minecraft.jungle_hanging_sign": "ტროპიკული ხის საკიდი აბრა",
  "block.minecraft.jungle_leaves": "ჯუნგლის ფოთლები",
  "block.minecraft.jungle_log": "ტროპიკული ხის მორი",
  "block.minecraft.jungle_planks": "ტროპიკული ხის ფიცრები",
  "block.minecraft.jungle_pressure_plate": "ტროპიკული ხის საჭერი ფირფიტა",
  "block.minecraft.jungle_sapling": "ჯუნგლის ხის ნერგი",
  "block.minecraft.jungle_shelf": "ტროპიკული ხის თარო",
  "block.minecraft.jungle_sign": "ტროპიკული ხის აბრა",
  "block.minecraft.jungle_slab": "ტროპიკული ხის ფილა",
  "block.minecraft.jungle_stairs": "ტროპიკული ხის საფეხურები",
  "block.minecraft.jungle_trapdoor": "ტროპიკული ხის სარკმელი",
  "block.minecraft.jungle_wall_hanging_sign": "ტროპიკული ხის კედლის საკიდი აბრა",
  "block.minecraft.jungle_wall_sign": "ტროპიკული ხის კედლის აბრა",
  "block.minecraft.jungle_wood": "ჯუნგლის ხე",
  "block.minecraft.kelp": "ლამინარია",
  "block.minecraft.kelp_plant": "ლამინარიას ღერო",
  "block.minecraft.ladder": "კიბე",
  "block.minecraft.lantern": "ლამპარი",
  "block.minecraft.lapis_block": "ლილაქვის ბლოკი",
  "block.minecraft.lapis_ore": "ლილაქვის მადანი",
  "block.minecraft.large_amethyst_bud": "დიდი ამეთვისტოს კვირტი",
  "block.minecraft.large_fern": "დიდი გვიმრა",
  "block.minecraft.lava": "ლავა",
  "block.minecraft.lava_cauldron": "ქვაბი ლავით",
  "block.minecraft.leaf_litter": "ჩამოცვენილი ფოთლები",
  "block.minecraft.lectern": "კათედრა",
  "block.minecraft.lever": "ბერკეტი",
  "block.minecraft.light": "სინათლე",
  "block.minecraft.light_blue_banner": "ცისფერი დროშა",
  "block.minecraft.light_blue_bed": "ცისფერი საწოლი",
  "block.minecraft.light_blue_candle": "ცისფერი სანთელი",
  "block.minecraft.light_blue_candle_cake": "ტორტი ცისფერი სანთლით",
  "block.minecraft.light_blue_carpet": "ცისფერი ხალიჩა",
  "block.minecraft.light_blue_concrete": "ცისფერი ბეტონი",
  "block.minecraft.light_blue_concrete_powder": "ცისფერი ცემენტი",
  "block.minecraft.light_blue_glazed_terracotta": "ცისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.light_blue_shulker_box": "ცისფერი შალკერ-ყუთი",
  "block.minecraft.light_blue_stained_glass": "ცისფერი შუშა",
  "block.minecraft.light_blue_stained_glass_pane": "ცისფერი მინა",
  "block.minecraft.light_blue_terracotta": "ცისფერი ტერაკოტა",
  "block.minecraft.light_blue_wool": "ცისფერი მატყლი",
  "block.minecraft.light_gray_banner": "ღია ნაცრისფერი დროშა",
  "block.minecraft.light_gray_bed": "ღია ნაცრისფერი საწოლი",
  "block.minecraft.light_gray_candle": "ღია ნაცრისფერი სანთელი",
  "block.minecraft.light_gray_candle_cake": "ტორტი ღია ნაცრისფერი სანთლით",
  "block.minecraft.light_gray_carpet": "ღია ნაცრისფერი ხალიჩა",
  "block.minecraft.light_gray_concrete": "ღია ნაცრისფერი ბეტონი",
  "block.minecraft.light_gray_concrete_powder": "ღია ნაცრისფერი ცემენტი",
  "block.minecraft.light_gray_glazed_terracotta": "ღია ნაცრისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.light_gray_shulker_box": "ღია ნაცრისფერი შალკერ-ყუთი",
  "block.minecraft.light_gray_stained_glass": "ღია ნაცრისფერი შუშა",
  "block.minecraft.light_gray_stained_glass_pane": "ღია ნაცრისფერი მინა",
  "block.minecraft.light_gray_terracotta": "ღია ნაცრისფერი ტერაკოტა",
  "block.minecraft.light_gray_wool": "ღია ნაცრისფერი მატყლი",
  "block.minecraft.light_weighted_pressure_plate": "მსუბუქი წონადობის საჭერი ფირფიტა",
  "block.minecraft.lightning_rod": "მეხამრიდი",
  "block.minecraft.lilac": "იასამანი",
  "block.minecraft.lily_of_the_valley": "შროშანა",
  "block.minecraft.lily_pad": "დუმფარა",
  "block.minecraft.lime_banner": "სალათისფერი დროშა",
  "block.minecraft.lime_bed": "სალათისფერი საწოლი",
  "block.minecraft.lime_candle": "სალათისფერი სანთელი",
  "block.minecraft.lime_candle_cake": "ტორტი სალათისფერი სანთლით",
  "block.minecraft.lime_carpet": "სალათისფერი ხალიჩა",
  "block.minecraft.lime_concrete": "სალათისფერი ბეტონი",
  "block.minecraft.lime_concrete_powder": "სალათისფერი ცემენტი",
  "block.minecraft.lime_glazed_terracotta": "სალათისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.lime_shulker_box": "სალათისფერი შალკერ-ყუთი",
  "block.minecraft.lime_stained_glass": "სალათისფერი შუშა",
  "block.minecraft.lime_stained_glass_pane": "სალათისფერი მინა",
  "block.minecraft.lime_terracotta": "სალათისფერი ტერაკოტა",
  "block.minecraft.lime_wool": "სალათისფერი მატყლი",
  "block.minecraft.lodestone": "მაგნეტიტი",
  "block.minecraft.loom": "საფეიქრო",
  "block.minecraft.magenta_banner": "იასამნისფერი დროშა",
  "block.minecraft.magenta_bed": "იასამნისფერი საწოლი",
  "block.minecraft.magenta_candle": "იასამნისფერი სანთელი",
  "block.minecraft.magenta_candle_cake": "ტორტი იასამნისფერი სანთლით",
  "block.minecraft.magenta_carpet": "იასამნისფერი ხალიჩა",
  "block.minecraft.magenta_concrete": "იასამნისფერი ბეტონი",
  "block.minecraft.magenta_concrete_powder": "იასამნისფერი ცემენტი",
  "block.minecraft.magenta_glazed_terracotta": "იასამნისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.magenta_shulker_box": "იასამნისფერი შალკერ-ყუთი",
  "block.minecraft.magenta_stained_glass": "იასამნისფერი შუშა",
  "block.minecraft.magenta_stained_glass_pane": "იასამნისფერი მინა",
  "block.minecraft.magenta_terracotta": "იასამნისფერი ტერაკოტა",
  "block.minecraft.magenta_wool": "იასამნისფერი მატყლი",
  "block.minecraft.magma_block": "მაგმის ბლოკი",
  "block.minecraft.mangrove_button": "მანგროვის ღილაკი",
  "block.minecraft.mangrove_door": "მანგროვის კარი",
  "block.minecraft.mangrove_fence": "მანგროვის ღობე",
  "block.minecraft.mangrove_fence_gate": "მანგროვის ჭიშკარი",
  "block.minecraft.mangrove_hanging_sign": "მანგროვის საკიდი აბრა",
  "block.minecraft.mangrove_leaves": "მანგროვის ფოთლები",
  "block.minecraft.mangrove_log": "მანგროვის მორი",
  "block.minecraft.mangrove_planks": "მანგროვის ფიცრები",
  "block.minecraft.mangrove_pressure_plate": "მანგროვის საჭერი ფირფიტა",
  "block.minecraft.mangrove_propagule": "მანგროვის ნაზარდი",
  "block.minecraft.mangrove_roots": "მანგროვის ფესვები",
  "block.minecraft.mangrove_shelf": "მანგროვის თარო",
  "block.minecraft.mangrove_sign": "მანგროვის აბრა",
  "block.minecraft.mangrove_slab": "მანგროვის ფილა",
  "block.minecraft.mangrove_stairs": "მანგროვის საფეხურები",
  "block.minecraft.mangrove_trapdoor": "მანგროვის სარკმელი",
  "block.minecraft.mangrove_wall_hanging_sign": "მანგროვის კედლის საკიდი აბრა",
  "block.minecraft.mangrove_wall_sign": "მანგროვის კედლის აბრა",
  "block.minecraft.mangrove_wood": "მანგროვის მერქანი",
  "block.minecraft.medium_amethyst_bud": "საშუალო ამეთვისტოს კვირტი",
  "block.minecraft.melon": "საზამთრო",
  "block.minecraft.melon_stem": "საზამთროს ღერო",
  "block.minecraft.moss_block": "ხავსის ბლოკი",
  "block.minecraft.moss_carpet": "ხავსის ხალიჩა",
  "block.minecraft.mossy_cobblestone": "ხავსიანი რიყის ქვა",
  "block.minecraft.mossy_cobblestone_slab": "ხავსიანი რიყის ქვის ფილა",
  "block.minecraft.mossy_cobblestone_stairs": "ხავსიანი რიყის ქვის საფეხურები",
  "block.minecraft.mossy_cobblestone_wall": "ხავსიანი რიყის ქვის ზღუდე",
  "block.minecraft.mossy_stone_brick_slab": "ხავსიანი ქვის აგურის ფილა",
  "block.minecraft.mossy_stone_brick_stairs": "ხავსიანი ქვის აგურის საფეხურები",
  "block.minecraft.mossy_stone_brick_wall": "ხავსიანი ქვის აგურის ზღუდე",
  "block.minecraft.mossy_stone_bricks": "ხავსიანი ქვის აგურები",
  "block.minecraft.moving_piston": "მოძრავი დგუში",
  "block.minecraft.mud": "ტალახი",
  "block.minecraft.mud_brick_slab": "ტალახის აგურის ფილა",
  "block.minecraft.mud_brick_stairs": "ტალახის აგურის საფეხურები",
  "block.minecraft.mud_brick_wall": "ტალახის აგურის ზღუდე",
  "block.minecraft.mud_bricks": "ტალახის აგურები",
  "block.minecraft.muddy_mangrove_roots": "ტალახიანი მანგროვის ფესვები",
  "block.minecraft.mushroom_stem": "სოკოს ფეხი",
  "block.minecraft.mycelium": "მიცელიუმი",
  "block.minecraft.nether_brick_fence": "ნეზერის აგურის ღობე",
  "block.minecraft.nether_brick_slab": "ნეზერის აგურის ფილა",
  "block.minecraft.nether_brick_stairs": "ნეზერის აგურის საფეხურები",
  "block.minecraft.nether_brick_wall": "ნეზერის აგურის ზღუდე",
  "block.minecraft.nether_bricks": "ნეზერის აგურები",
  "block.minecraft.nether_gold_ore": "ნეზერის ოქროს მადანი",
  "block.minecraft.nether_portal": "ნეზერის პორტალი",
  "block.minecraft.nether_quartz_ore": "ნეზერის კვარცის მადანი",
  "block.minecraft.nether_sprouts": "ნეზერის ყლორტები",
  "block.minecraft.nether_wart": "ნეზერის მეჭეჭა",
  "block.minecraft.nether_wart_block": "ნეზერის მეჭეჭას ბლოკი",
  "block.minecraft.netherite_block": "ნეზერიტის ბლოკი",
  "block.minecraft.netherrack": "ნეზერაკი",
  "block.minecraft.note_block": "ნოტების ბლოკი",
  "block.minecraft.oak_button": "მუხის ღილაკი",
  "block.minecraft.oak_door": "მუხის კარი",
  "block.minecraft.oak_fence": "მუხის ღობე",
  "block.minecraft.oak_fence_gate": "მუხის ჭიშკარი",
  "block.minecraft.oak_hanging_sign": "მუხის საკიდი აბრა",
  "block.minecraft.oak_leaves": "მუხის ფოთლები",
  "block.minecraft.oak_log": "მუხის მორი",
  "block.minecraft.oak_planks": "მუხის ფიცრები",
  "block.minecraft.oak_pressure_plate": "მუხის საჭერი ფირფიტა",
  "block.minecraft.oak_sapling": "მუხის ნერგი",
  "block.minecraft.oak_shelf": "მუხის თარო",
  "block.minecraft.oak_sign": "მუხის აბრა",
  "block.minecraft.oak_slab": "მუხის ფილა",
  "block.minecraft.oak_stairs": "მუხის საფეხურები",
  "block.minecraft.oak_trapdoor": "მუხის სარკმელი",
  "block.minecraft.oak_wall_hanging_sign": "მუხის კედლის საკიდი აბრა",
  "block.minecraft.oak_wall_sign": "მუხის კედლის აბრა",
  "block.minecraft.oak_wood": "მუხის მერქანი",
  "block.minecraft.observer": "მეთვალყურე",
  "block.minecraft.obsidian": "ობსიდიანი",
  "block.minecraft.ochre_froglight": "ოქროსფერი ყიყინათობი",
  "block.minecraft.ominous_banner": "ავბედი დროშა",
  "block.minecraft.open_eyeblossom": "ღია თვალყვავილა",
  "block.minecraft.orange_banner": "ნარინჯისფერი დროშა",
  "block.minecraft.orange_bed": "ნარინჯისფერი საწოლი",
  "block.minecraft.orange_candle": "ნარინჯისფერი სანთელი",
  "block.minecraft.orange_candle_cake": "ტორტი ნარინჯისფერი სანთლით",
  "block.minecraft.orange_carpet": "ნარინჯისფერი ხალიჩა",
  "block.minecraft.orange_concrete": "ნარინჯისფერი ბეტონი",
  "block.minecraft.orange_concrete_powder": "ნარინჯისფერი ცემენტი",
  "block.minecraft.orange_glazed_terracotta": "ნარინჯისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.orange_shulker_box": "ნარინჯისფერი შალკერ-ყუთი",
  "block.minecraft.orange_stained_glass": "ნარინჯისფერი შუშა",
  "block.minecraft.orange_stained_glass_pane": "ნარინჯისფერი მინა",
  "block.minecraft.orange_terracotta": "ნარინჯისფერი ტერაკოტა",
  "block.minecraft.orange_tulip": "ნარინჯისფერი ტიტა",
  "block.minecraft.orange_wool": "ნარინჯისფერი მატყლი",
  "block.minecraft.oxeye_daisy": "გვირილა",
  "block.minecraft.oxidized_chiseled_copper": "დაჟანგული მოჩუქურთმებული სპილენძი",
  "block.minecraft.oxidized_copper": "დაჟანგული სპილენძი",
  "block.minecraft.oxidized_copper_bars": "დაჟანგული სპილენძის გისოსები",
  "block.minecraft.oxidized_copper_bulb": "დაჟანგული სპილენძის ნათურა",
  "block.minecraft.oxidized_copper_chain": "დაჟანგული სპილენძის ჯაჭვი",
  "block.minecraft.oxidized_copper_chest": "დაჟანგული სპილენძის სკივრი",
  "block.minecraft.oxidized_copper_door": "დაჟანგული სპილენძის კარი",
  "block.minecraft.oxidized_copper_golem_statue": "დაჟანგული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.oxidized_copper_grate": "დაჟანგული სპილენძის ცხაურა",
  "block.minecraft.oxidized_copper_lantern": "დაჟანგული სპილენძის ლამპარი",
  "block.minecraft.oxidized_copper_trapdoor": "დაჟანგული სპილენძის სარკმელი",
  "block.minecraft.oxidized_cut_copper": "დაჟანგული მოჭრილი სპილენძი",
  "block.minecraft.oxidized_cut_copper_slab": "დაჟანგული მოჭრილი სპილენძის ფილა",
  "block.minecraft.oxidized_cut_copper_stairs": "დაჟანგული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.oxidized_lightning_rod": "დაჟანგული მეხამრიდი",
  "block.minecraft.packed_ice": "მკვრივი ყინული",
  "block.minecraft.packed_mud": "მყარი ტალახი",
  "block.minecraft.pale_hanging_moss": "მკრთადი დაკიდული ხავსი",
  "block.minecraft.pale_moss_block": "მკრთალი ხავსის ბლოკი",
  "block.minecraft.pale_moss_carpet": "მკრთალი ხავსის ხალიჩა",
  "block.minecraft.pale_oak_button": "მკრთალი მუხის ღილაკი",
  "block.minecraft.pale_oak_door": "მკრთალი მუხის კარი",
  "block.minecraft.pale_oak_fence": "მკრთალი მუხის ღობე",
  "block.minecraft.pale_oak_fence_gate": "მკრთალი მუხის ჭიშკარი",
  "block.minecraft.pale_oak_hanging_sign": "მკრთალი მუხის საკიდი აბრა",
  "block.minecraft.pale_oak_leaves": "მკრთალი მუხის ფოთლები",
  "block.minecraft.pale_oak_log": "მკრთალი მუხის მორი",
  "block.minecraft.pale_oak_planks": "მკრთალი მუხის ფიცრები",
  "block.minecraft.pale_oak_pressure_plate": "მკრთალი მუხის საჭერი ფირფიტა",
  "block.minecraft.pale_oak_sapling": "მკრთალი მუხის ნერგი",
  "block.minecraft.pale_oak_shelf": "მკრთალი მუხის თარო",
  "block.minecraft.pale_oak_sign": "მკრთალი მუხის აბრა",
  "block.minecraft.pale_oak_slab": "მკრთალი მუხის ფილა",
  "block.minecraft.pale_oak_stairs": "მკრთალი მუხის საფეხურები",
  "block.minecraft.pale_oak_trapdoor": "მკრთალი მუხის სარკმელი",
  "block.minecraft.pale_oak_wall_hanging_sign": "მკრთალი მუხის კედლის საკიდი აბრა",
  "block.minecraft.pale_oak_wall_sign": "მკრთალი მუხის კედლის აბრა",
  "block.minecraft.pale_oak_wood": "მკრთალი მუხის მერქანი",
  "block.minecraft.pearlescent_froglight": "მარგალიტისფერი ყიყინათობი",
  "block.minecraft.peony": "იორდასალამი",
  "block.minecraft.petrified_oak_slab": "გაქვავებული მუხის ფილა",
  "block.minecraft.piglin_head": "პიგლინის თავი",
  "block.minecraft.piglin_wall_head": "პიგლინის კედლის თავი",
  "block.minecraft.pink_banner": "ვარდისფერი დროშა",
  "block.minecraft.pink_bed": "ვარდისფერი საწოლი",
  "block.minecraft.pink_candle": "ვარდისფერი სანთელი",
  "block.minecraft.pink_candle_cake": "ტორტი ვარდისფერი სანთლით",
  "block.minecraft.pink_carpet": "ვარდისფერი ხალიჩა",
  "block.minecraft.pink_concrete": "ვარდისფერი ბეტონი",
  "block.minecraft.pink_concrete_powder": "ვარდისფერი ცემენტი",
  "block.minecraft.pink_glazed_terracotta": "ვარდისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.pink_petals": "ვარდისფერი ფურცლები",
  "block.minecraft.pink_shulker_box": "ვარდისფერი შალკერ-ყუთი",
  "block.minecraft.pink_stained_glass": "ვარდისფერი შუშა",
  "block.minecraft.pink_stained_glass_pane": "ვარდისფერი მინა",
  "block.minecraft.pink_terracotta": "ვარდისფერი ტერაკოტა",
  "block.minecraft.pink_tulip": "ვარდისფერი ტიტა",
  "block.minecraft.pink_wool": "ვარდისფერი მატყლი",
  "block.minecraft.piston": "დგუში",
  "block.minecraft.piston_head": "დგუშის თავი",
  "block.minecraft.pitcher_crop": "ქვევრის ყლორტი",
  "block.minecraft.pitcher_plant": "ქვევრი",
  "block.minecraft.player_head": "მოთამაშის თავი",
  "block.minecraft.player_head.named": "%s-(ი)ს თავი",
  "block.minecraft.player_wall_head": "მოთამაშის კედლის თავი",
  "block.minecraft.podzol": "ეწერი",
  "block.minecraft.pointed_dripstone": "სტალაქტიტი",
  "block.minecraft.polished_andesite": "გაპრიალებული ანდეზიტი",
  "block.minecraft.polished_andesite_slab": "გაპრიალებული ანდეზიტის ფილა",
  "block.minecraft.polished_andesite_stairs": "გაპრიალებული ანდეზიტის საფეხურები",
  "block.minecraft.polished_basalt": "გაპრიალებული ბაზალტი",
  "block.minecraft.polished_blackstone": "გაპრიალებული შავქვა",
  "block.minecraft.polished_blackstone_brick_slab": "გაპრიალებული შავქვის აგურის ფილა",
  "block.minecraft.polished_blackstone_brick_stairs": "გაპრიალებული შავქვის აგურის საფეხურები",
  "block.minecraft.polished_blackstone_brick_wall": "გაპრიალებული შავქვის აგურის ზღუდე",
  "block.minecraft.polished_blackstone_bricks": "გაპრიალებული შავქვის აგურები",
  "block.minecraft.polished_blackstone_button": "გაპრიალებული შავქვის ღილაკი",
  "block.minecraft.polished_blackstone_pressure_plate": "გაპრიალებული შავქვის საჭერი ფირფიტა",
  "block.minecraft.polished_blackstone_slab": "გაპრიალებული შავქვის ფილა",
  "block.minecraft.polished_blackstone_stairs": "გაპრიალებული შავქვის საფეხურები",
  "block.minecraft.polished_blackstone_wall": "გაპრიალებული შავქვის ზღუდე",
  "block.minecraft.polished_deepslate": "გაპრიალებული სიღრმის ფიქალი",
  "block.minecraft.polished_deepslate_slab": "გაპრიალებული სიღრმის ფიქალის ფილა",
  "block.minecraft.polished_deepslate_stairs": "გაპრიალებული სიღრმის ფიქალის საფეხურები",
  "block.minecraft.polished_deepslate_wall": "გაპრიალებული სიღრმის ფიქალის ზღუდე",
  "block.minecraft.polished_diorite": "გაპრიალებული დიორიტი",
  "block.minecraft.polished_diorite_slab": "გაპრიალებული დიორიტის ფილა",
  "block.minecraft.polished_diorite_stairs": "გაპრიალებული დიორიტის საფეხურები",
  "block.minecraft.polished_granite": "გაპრიალებული გრანიტი",
  "block.minecraft.polished_granite_slab": "გაპრიალებული გრანიტის ფილა",
  "block.minecraft.polished_granite_stairs": "გაპრიალებული გრანიტის საფეხურები",
  "block.minecraft.polished_tuff": "გაპრიალებული ტუფი",
  "block.minecraft.polished_tuff_slab": "გაპრიალებული ტუფის ფილა",
  "block.minecraft.polished_tuff_stairs": "გაპრიალებული ტუფის საფეხურები",
  "block.minecraft.polished_tuff_wall": "გაპრიალებული ტუფის ზღუდე",
  "block.minecraft.poppy": "ყაყაჩო",
  "block.minecraft.potatoes": "კარტოფილები",
  "block.minecraft.potted_acacia_sapling": "აკაციის ნერგი ქოთანში",
  "block.minecraft.potted_allium": "ჭლაკვი ქოთანში",
  "block.minecraft.potted_azalea_bush": "აზალია ქოთანში",
  "block.minecraft.potted_azure_bluet": "ცისფერი ჟასმინი ქოთანში",
  "block.minecraft.potted_bamboo": "ბამბუკი ქოთანში",
  "block.minecraft.potted_birch_sapling": "არყის ნერგი ქოთანში",
  "block.minecraft.potted_blue_orchid": "ლურჯი ორქიდეა ქოთანში",
  "block.minecraft.potted_brown_mushroom": "ყავისფერი სოკო ქოთანში",
  "block.minecraft.potted_cactus": "კაქტუსი ქოთანში",
  "block.minecraft.potted_cherry_sapling": "ალუბლის ნერგი ქოთანში",
  "block.minecraft.potted_closed_eyeblossom": "დახურული თვალყვავილა ქოთანში",
  "block.minecraft.potted_cornflower": "ღიღილო ქოთანში",
  "block.minecraft.potted_crimson_fungus": "ჟოლოსფერი სოკო ქოთანში",
  "block.minecraft.potted_crimson_roots": "ჟოლოსფერი ფესვები ქოთანში",
  "block.minecraft.potted_dandelion": "ბაბუაწვერა ქოთანში",
  "block.minecraft.potted_dark_oak_sapling": "მუქი მუხის ნერგი ქოთანში",
  "block.minecraft.potted_dead_bush": "გამხმარი ბუჩქი ქოთანში",
  "block.minecraft.potted_fern": "გვიმრა ქოთანში",
  "block.minecraft.potted_flowering_azalea_bush": "აყვავებული აზალია ქოთანში",
  "block.minecraft.potted_golden_dandelion": "ოქროს ბაბუაწვერა ქოთანში",
  "block.minecraft.potted_jungle_sapling": "ტროპიკული ხის ნერგი ქოთანში",
  "block.minecraft.potted_lily_of_the_valley": "შროშანა ქოთანში",
  "block.minecraft.potted_mangrove_propagule": "მანგროვის ნაზარდი ქოთანში",
  "block.minecraft.potted_oak_sapling": "მუხის ნერგი ქოთანში",
  "block.minecraft.potted_open_eyeblossom": "ღია თვალყვავილა ქოთანში",
  "block.minecraft.potted_orange_tulip": "ნარინჯისფერი ტიტა ქოთანში",
  "block.minecraft.potted_oxeye_daisy": "გვირილა ქოთანში",
  "block.minecraft.potted_pale_oak_sapling": "მკრთალი მუხის ნერგი ქოთანში",
  "block.minecraft.potted_pink_tulip": "ვარდისფერი ტიტა ქოთანში",
  "block.minecraft.potted_poppy": "ყაყაჩო ქოთანში",
  "block.minecraft.potted_red_mushroom": "წითელი სოკო ქოთანში",
  "block.minecraft.potted_red_tulip": "წითელი ტიტა ქოთანში",
  "block.minecraft.potted_spruce_sapling": "ნაძვის ნერგი ქოთანში",
  "block.minecraft.potted_torchflower": "ჩირაღდანა ქოთანში",
  "block.minecraft.potted_warped_fungus": "დაბრეცილი სოკო ქოთანში",
  "block.minecraft.potted_warped_roots": "დაბრეცილი ფესვები ქოთანში",
  "block.minecraft.potted_white_tulip": "თეთრი ტიტა ქოთანში",
  "block.minecraft.potted_wither_rose": "ვიზერის ვარდი ქოთანში",
  "block.minecraft.powder_snow": "ფხვიერი თოვლი",
  "block.minecraft.powder_snow_cauldron": "ქვაბი ფხვიერი თოვლით",
  "block.minecraft.powered_rail": "ამაჩქარებელი",
  "block.minecraft.prismarine": "პრიზმარინი",
  "block.minecraft.prismarine_brick_slab": "პრიზმარინის აგურის ფილა",
  "block.minecraft.prismarine_brick_stairs": "პრიზმარინის აგურის საფეხურები",
  "block.minecraft.prismarine_bricks": "პრიზმარინის აგურები",
  "block.minecraft.prismarine_slab": "პრიზმარინის ფილა",
  "block.minecraft.prismarine_stairs": "პრიზმარინის საფეხურები",
  "block.minecraft.prismarine_wall": "პრიზმარინის ზღუდე",
  "block.minecraft.pumpkin": "გოგრა",
  "block.minecraft.pumpkin_stem": "გოგრის ღერო",
  "block.minecraft.purple_banner": "იისფერი დროშა",
  "block.minecraft.purple_bed": "იისფერი საწოლი",
  "block.minecraft.purple_candle": "იისფერი სანთელი",
  "block.minecraft.purple_candle_cake": "ტორტი იისფერი სანთლით",
  "block.minecraft.purple_carpet": "იისფერი ხალიჩა",
  "block.minecraft.purple_concrete": "იისფერი ბეტონი",
  "block.minecraft.purple_concrete_powder": "იისფერი ცემენტი",
  "block.minecraft.purple_glazed_terracotta": "იისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.purple_shulker_box": "იისფერი შალკერ-ყუთი",
  "block.minecraft.purple_stained_glass": "იისფერი შუშა",
  "block.minecraft.purple_stained_glass_pane": "იისფერი მინა",
  "block.minecraft.purple_terracotta": "იისფერი ტერაკოტა",
  "block.minecraft.purple_wool": "იისფერი მატყლი",
  "block.minecraft.purpur_block": "პურპურის ბლოკი",
  "block.minecraft.purpur_pillar": "პურპურის სვეტი",
  "block.minecraft.purpur_slab": "პურპურის ფილა",
  "block.minecraft.purpur_stairs": "პურპურის საფეხურები",
  "block.minecraft.quartz_block": "კვარცის ბლოკი",
  "block.minecraft.quartz_bricks": "კვარცის აგურები",
  "block.minecraft.quartz_pillar": "კვარცის სვეტი",
  "block.minecraft.quartz_slab": "კვარცის ფილა",
  "block.minecraft.quartz_stairs": "კვარცის საფეხურები",
  "block.minecraft.rail": "რელსი",
  "block.minecraft.raw_copper_block": "ნედლი სპილენძის ბლოკი",
  "block.minecraft.raw_gold_block": "ნედლი ოქროს ბლოკი",
  "block.minecraft.raw_iron_block": "ნედლი რკინის ბლოკი",
  "block.minecraft.red_banner": "წითელი დროშა",
  "block.minecraft.red_bed": "წითელი საწოლი",
  "block.minecraft.red_candle": "წითელი სანთელი",
  "block.minecraft.red_candle_cake": "ტორტი წითელი სანთლით",
  "block.minecraft.red_carpet": "წითელი ხალიჩა",
  "block.minecraft.red_concrete": "წითელი ბეტონი",
  "block.minecraft.red_concrete_powder": "წითელი ცემენტი",
  "block.minecraft.red_glazed_terracotta": "წითელი მოჭიქული ტერაკოტა",
  "block.minecraft.red_mushroom": "წითელი სოკო",
  "block.minecraft.red_mushroom_block": "წითელი სოკოს ბლოკი",
  "block.minecraft.red_nether_brick_slab": "წითელი ნეზერის აგურის ფილა",
  "block.minecraft.red_nether_brick_stairs": "წითელი ნეზერის აგურის საფეხურები",
  "block.minecraft.red_nether_brick_wall": "წითელი ნეზერის აგურის ზღუდე",
  "block.minecraft.red_nether_bricks": "წითელი ნეზერის აგურები",
  "block.minecraft.red_sand": "წითელი ქვიშა",
  "block.minecraft.red_sandstone": "წითელი ქვიშაქვა",
  "block.minecraft.red_sandstone_slab": "წითელი ქვიშაქვის ფილა",
  "block.minecraft.red_sandstone_stairs": "წითელი ქვიშაქვის საფეხურები",
  "block.minecraft.red_sandstone_wall": "წითელი ქვიშაქვის ზღუდე",
  "block.minecraft.red_shulker_box": "წითელი შალკერ-ყუთი",
  "block.minecraft.red_stained_glass": "წითელი შუშა",
  "block.minecraft.red_stained_glass_pane": "წითელი მინა",
  "block.minecraft.red_terracotta": "წითელი ტერაკოტა",
  "block.minecraft.red_tulip": "წითელი ტიტა",
  "block.minecraft.red_wool": "წითელი მატყლი",
  "block.minecraft.redstone_block": "რედსტოუნის ბლოკი",
  "block.minecraft.redstone_lamp": "რედსტოუნის ნათურა",
  "block.minecraft.redstone_ore": "რედსტოუნის მადანი",
  "block.minecraft.redstone_torch": "რედსტოუნის ჩირაღდანი",
  "block.minecraft.redstone_wall_torch": "რედსტოუნის კედლის ჩირაღდანი",
  "block.minecraft.redstone_wire": "რედსტოუნის სადენი",
  "block.minecraft.reinforced_deepslate": "გამაგრებული სიღრმის ფიქალი",
  "block.minecraft.repeater": "რედსტოუნის მამეორებელი",
  "block.minecraft.repeating_command_block": "მამეორებელი ბრძანების ბლოკი",
  "block.minecraft.resin_block": "ფისის ბლოკი",
  "block.minecraft.resin_brick_slab": "ფისის აგურის ფილა",
  "block.minecraft.resin_brick_stairs": "ფისის აგურის საფეხურები",
  "block.minecraft.resin_brick_wall": "ფისის აგურის ზღუდე",
  "block.minecraft.resin_bricks": "ფისის აგურები",
  "block.minecraft.resin_clump": "ფისის შენადენი",
  "block.minecraft.respawn_anchor": "გაცოცხლების ღუზა",
  "block.minecraft.rooted_dirt": "ფესვებიანი მიწა",
  "block.minecraft.rose_bush": "ვარდის ბუჩქი",
  "block.minecraft.sand": "ქვიშა",
  "block.minecraft.sandstone": "ქვიშაქვა",
  "block.minecraft.sandstone_slab": "ქვიშაქვის ფილა",
  "block.minecraft.sandstone_stairs": "ქვიშაქვის საფეხურები",
  "block.minecraft.sandstone_wall": "ქვიშაქვის ზღუდე",
  "block.minecraft.scaffolding": "ხარაჩო",
  "block.minecraft.sculk": "სკალკი",
  "block.minecraft.sculk_catalyst": "სკალკ-კატალიზატორი",
  "block.minecraft.sculk_sensor": "სკალკ-სენსორი",
  "block.minecraft.sculk_shrieker": "სკალკ-მყვირალა",
  "block.minecraft.sculk_vein": "სკალკის ძარღვი",
  "block.minecraft.sea_lantern": "ზღვის სანათი",
  "block.minecraft.sea_pickle": "ზღვის კიტრი",
  "block.minecraft.seagrass": "ზღვის ბალახი",
  "block.minecraft.set_spawn": "მოინიშნა გაცოცხლების წერტილი",
  "block.minecraft.short_dry_grass": "დაბალი ხმელი ბალახი",
  "block.minecraft.short_grass": "დაბალი ბალახი",
  "block.minecraft.shroomlight": "ნათობსოკო",
  "block.minecraft.shulker_box": "შალკერ-ყუთი",
  "block.minecraft.skeleton_skull": "ჩონჩხის თავის ქალა",
  "block.minecraft.skeleton_wall_skull": "ჩონჩხის კედლის თავის ქალა",
  "block.minecraft.slime_block": "ლორწოს ბლოკი",
  "block.minecraft.small_amethyst_bud": "პატარა ამეთვისტოს კვირტი",
  "block.minecraft.small_dripleaf": "პატარა წვეთფოთოლა",
  "block.minecraft.smithing_table": "სამჭედლო მაგიდა",
  "block.minecraft.smoker": "საბოლველი",
  "block.minecraft.smooth_basalt": "გლუვი ბაზალტი",
  "block.minecraft.smooth_quartz": "გლუვი კვარცის ბლოკი",
  "block.minecraft.smooth_quartz_slab": "გლუვი კვარცის ფილა",
  "block.minecraft.smooth_quartz_stairs": "გლუვი კვარცის საფეხურები",
  "block.minecraft.smooth_red_sandstone": "გლუვი წითელი ქვიშაქვა",
  "block.minecraft.smooth_red_sandstone_slab": "გლუვი წითელი ქვიშაქვის ფილა",
  "block.minecraft.smooth_red_sandstone_stairs": "გლუვი წითელი ქვიშაქვის საფეხურები",
  "block.minecraft.smooth_sandstone": "გლუვი ქვიშაქვა",
  "block.minecraft.smooth_sandstone_slab": "გლუვი ქვიშაქვის ფილა",
  "block.minecraft.smooth_sandstone_stairs": "გლუვი ქვიშაქვის საფეხურები",
  "block.minecraft.smooth_stone": "გლუვი ქვა",
  "block.minecraft.smooth_stone_slab": "გლუვი ქვის ფილა",
  "block.minecraft.sniffer_egg": "მყნოსველის კვერცხი",
  "block.minecraft.snow": "თოვლი",
  "block.minecraft.snow_block": "თოვლის ბლოკი",
  "block.minecraft.soul_campfire": "სულთა კოცონი",
  "block.minecraft.soul_fire": "სულთა ცეცხლი",
  "block.minecraft.soul_lantern": "სულთა ლამპარი",
  "block.minecraft.soul_sand": "სულთა ქვიშა",
  "block.minecraft.soul_soil": "სულთა ნიადაგი",
  "block.minecraft.soul_torch": "სულთა ჩირაღდანი",
  "block.minecraft.soul_wall_torch": "სულთა კედლის ჩირაღდანი",
  "block.minecraft.spawn.not_valid": "თქვენ არ გაქვთ საწოლი ან დამუხტული გაცოცხლების ღუზა ან მათთან წვდომას აქვს დაბრკოლება",
  "block.minecraft.spawner": "მონსტრების გამომძახებელი",
  "block.minecraft.spawner.desc1": "ურთიერთქმედება გამოძახების კვერცხთან:",
  "block.minecraft.spawner.desc2": "განსაზღვრავს მობის ტიპს",
  "block.minecraft.sponge": "ღრუბელი",
  "block.minecraft.spore_blossom": "სპორული ყვავილი",
  "block.minecraft.spruce_button": "ნაძვის ღილაკი",
  "block.minecraft.spruce_door": "ნაძვის კარი",
  "block.minecraft.spruce_fence": "ნაძვის ღობე",
  "block.minecraft.spruce_fence_gate": "ნაძვის ჭიშკარი",
  "block.minecraft.spruce_hanging_sign": "ნაძვის საკიდი აბრა",
  "block.minecraft.spruce_leaves": "ნაძვის წიწვები",
  "block.minecraft.spruce_log": "ნაძვის მორი",
  "block.minecraft.spruce_planks": "ნაძვის ფიცრები",
  "block.minecraft.spruce_pressure_plate": "ნაძვის საჭერი ფირფიტა",
  "block.minecraft.spruce_sapling": "ნაძვის ნერგი",
  "block.minecraft.spruce_shelf": "ნაძვის თარო",
  "block.minecraft.spruce_sign": "ნაძვის აბრა",
  "block.minecraft.spruce_slab": "ნაძვის ფილა",
  "block.minecraft.spruce_stairs": "ნაძვის საფეხურები",
  "block.minecraft.spruce_trapdoor": "ნაძვის სარკმელი",
  "block.minecraft.spruce_wall_hanging_sign": "ნაძვის კედლის საკიდი აბრა",
  "block.minecraft.spruce_wall_sign": "ნაძვის კედლის აბრა",
  "block.minecraft.spruce_wood": "ნაძვის მერქანი",
  "block.minecraft.sticky_piston": "წებოვანი დგუში",
  "block.minecraft.stone": "ქვა",
  "block.minecraft.stone_brick_slab": "ქვის აგურის ფილა",
  "block.minecraft.stone_brick_stairs": "ქვის აგურის საფეხურები",
  "block.minecraft.stone_brick_wall": "ქვის აგურის ზღუდე",
  "block.minecraft.stone_bricks": "ქვის აგურები",
  "block.minecraft.stone_button": "ქვის ღილაკი",
  "block.minecraft.stone_pressure_plate": "ქვის საჭერი ფირფიტა",
  "block.minecraft.stone_slab": "ქვის ფილა",
  "block.minecraft.stone_stairs": "ქვის საფეხურები",
  "block.minecraft.stonecutter": "ქვისმჭრელი",
  "block.minecraft.stripped_acacia_log": "გათლილი აკაციის მორი",
  "block.minecraft.stripped_acacia_wood": "გათლილი აკაცია",
  "block.minecraft.stripped_bamboo_block": "გათლილი ბამბუკის ბლოკი",
  "block.minecraft.stripped_birch_log": "გათლილი არყის მორი",
  "block.minecraft.stripped_birch_wood": "გათლილი არყის მერქანი",
  "block.minecraft.stripped_cherry_log": "გათლილი ალუბლის მორი",
  "block.minecraft.stripped_cherry_wood": "გათლილი ალუბლის მერქანი",
  "block.minecraft.stripped_crimson_hyphae": "გათლილი ჟოლოსფერი ჰიფები",
  "block.minecraft.stripped_crimson_stem": "გათლილი ჟოლოსფერი ღერო",
  "block.minecraft.stripped_dark_oak_log": "გათლილი მუქი მუხის მორი",
  "block.minecraft.stripped_dark_oak_wood": "გათლილი მუქი მუხის მერქანი",
  "block.minecraft.stripped_jungle_log": "გათლილი ტროპიკული ხის მორი",
  "block.minecraft.stripped_jungle_wood": "გათლილი ტროპიკული ხის მერქანი",
  "block.minecraft.stripped_mangrove_log": "გათლილი მანგროვის მორი",
  "block.minecraft.stripped_mangrove_wood": "გათლილი მანგროვის მერქანი",
  "block.minecraft.stripped_oak_log": "გათლილი მუხის მორი",
  "block.minecraft.stripped_oak_wood": "გათლილი მუხის მერქანი",
  "block.minecraft.stripped_pale_oak_log": "გათლილი მკრთალი მუხის მორი",
  "block.minecraft.stripped_pale_oak_wood": "გათლილი მკრთალი მუხის მერქანი",
  "block.minecraft.stripped_spruce_log": "გათლილი ნაძვის მორი",
  "block.minecraft.stripped_spruce_wood": "გათლილი ნაძვის მერქანი",
  "block.minecraft.stripped_warped_hyphae": "გათლილი დაბრეცილი ჰიფები",
  "block.minecraft.stripped_warped_stem": "გათლილი დაბრეცილი ღერო",
  "block.minecraft.structure_block": "კონსტრუქციის ბლოკი",
  "block.minecraft.structure_void": "ცარიელი ბლოკი",
  "block.minecraft.sugar_cane": "შაქრის ლერწამი",
  "block.minecraft.sunflower": "მზესუმზირა",
  "block.minecraft.suspicious_gravel": "საეჭვო ხრეში",
  "block.minecraft.suspicious_sand": "საეჭვი ქვიშა",
  "block.minecraft.sweet_berry_bush": "ტკბილი კენკრის ბუჩქი",
  "block.minecraft.tall_dry_grass": "მაღალი ხმელი ბალახი",
  "block.minecraft.tall_grass": "მაღალი ბალახი",
  "block.minecraft.tall_seagrass": "მაღალი ზღვის ბალახი",
  "block.minecraft.target": "სამიზნე",
  "block.minecraft.terracotta": "ტერაკოტა",
  "block.minecraft.test_block": "ბლოკი-ტესტერი",
  "block.minecraft.test_instance_block": "ნიმუშის ბლოკი-ტესტერი",
  "block.minecraft.tinted_glass": "შეფერილი შუშა",
  "block.minecraft.tnt": "დინამიტი",
  "block.minecraft.tnt.disabled": "დინამიტის აფეთქებები გამორთულია",
  "block.minecraft.torch": "ჩირაღდანი",
  "block.minecraft.torchflower": "ჩირაღდანა",
  "block.minecraft.torchflower_crop": "ჩირაღდანას ყლორტი",
  "block.minecraft.trapped_chest": "ხაფანგიანი სკივრი",
  "block.minecraft.trial_spawner": "გამოწვევების გამომძახებელი",
  "block.minecraft.tripwire": "ხაფანგი",
  "block.minecraft.tripwire_hook": "ხაფანგის კაუჭი",
  "block.minecraft.tube_coral": "მილაკოვანი მარჯანი",
  "block.minecraft.tube_coral_block": "მილაკოვანი მარჯნის ბლოკი",
  "block.minecraft.tube_coral_fan": "მილაკოვანი მარაოსებრი მარჯანი",
  "block.minecraft.tube_coral_wall_fan": "მილაკოვანი მარაოსებრი მარჯანი კედელზე",
  "block.minecraft.tuff": "ტუფი",
  "block.minecraft.tuff_brick_slab": "ტუფის აგურის ფილა",
  "block.minecraft.tuff_brick_stairs": "ტუფის აგურის საფეხურები",
  "block.minecraft.tuff_brick_wall": "ტუფის აგურის ზღუდე",
  "block.minecraft.tuff_bricks": "ტუფის აგურები",
  "block.minecraft.tuff_slab": "ტუფის ფილა",
  "block.minecraft.tuff_stairs": "ტუფის საფეხურები",
  "block.minecraft.tuff_wall": "ტუფის ზღუდე",
  "block.minecraft.turtle_egg": "კუს კვერცხი",
  "block.minecraft.twisting_vines": "ხვეული სურო",
  "block.minecraft.twisting_vines_plant": "ხვეული სუროს ღერო",
  "block.minecraft.vault": "საცავი",
  "block.minecraft.verdant_froglight": "ზურმუხტისფერი ყიყინათობი",
  "block.minecraft.vine": "სურო",
  "block.minecraft.void_air": "უფსკრულის ჰაერი",
  "block.minecraft.wall_torch": "კედლის ჩირაღდანი",
  "block.minecraft.warped_button": "დაბრეცილი ღილაკი",
  "block.minecraft.warped_door": "დაბრეცილი კარი",
  "block.minecraft.warped_fence": "დაბრეცილი ღობე",
  "block.minecraft.warped_fence_gate": "დაბრეცილი ჭიშკარი",
  "block.minecraft.warped_fungus": "დაბრეცილი სოკო",
  "block.minecraft.warped_hanging_sign": "დაბრეცილი საკიდი აბრა",
  "block.minecraft.warped_hyphae": "დაბრეცილი ჰიფები",
  "block.minecraft.warped_nylium": "დაბრეცილი ნილიუმი",
  "block.minecraft.warped_planks": "დაბრეცილი ფიცრები",
  "block.minecraft.warped_pressure_plate": "დაბრეცილი საჭერი ფირფიტა",
  "block.minecraft.warped_roots": "დაბრეცილი ფესვები",
  "block.minecraft.warped_shelf": "დაბრეცილი თარო",
  "block.minecraft.warped_sign": "დაბრეცილი აბრა",
  "block.minecraft.warped_slab": "დაბრეცილი ფილა",
  "block.minecraft.warped_stairs": "დაბრეცილი საფეხურები",
  "block.minecraft.warped_stem": "დაბრეცილი ღერო",
  "block.minecraft.warped_trapdoor": "დაბრეცილი სარკმელი",
  "block.minecraft.warped_wall_hanging_sign": "დაბრეცილი კედლის საკიდი აბრა",
  "block.minecraft.warped_wall_sign": "დაბრეცილი კედლის აბრა",
  "block.minecraft.warped_wart_block": "დაბრეცილი მეჭეჭის ბლოკი",
  "block.minecraft.water": "წყალი",
  "block.minecraft.water_cauldron": "ქვაბი წყლით",
  "block.minecraft.waxed_chiseled_copper": "გაცვილული მოჩუქურთმებული სპილენძი",
  "block.minecraft.waxed_copper_bars": "გაცვილული სპილენძის გისოსები",
  "block.minecraft.waxed_copper_block": "გაცვილული სპილენძის ბლოკი",
  "block.minecraft.waxed_copper_bulb": "გაცვილული სპილენძის ნათურა",
  "block.minecraft.waxed_copper_chain": "გაცვილული სპილენძის ჯაჭვი",
  "block.minecraft.waxed_copper_chest": "გაცვილული სპილენძის სკივრი",
  "block.minecraft.waxed_copper_door": "გაცვილული სპილენძის კარი",
  "block.minecraft.waxed_copper_golem_statue": "გაცვილული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.waxed_copper_grate": "გაცვილული სპილენძის ცხაურა",
  "block.minecraft.waxed_copper_lantern": "გაცვილული სპილენძის ლამპარი",
  "block.minecraft.waxed_copper_trapdoor": "გაცვილული სპილენძის სარკმელი",
  "block.minecraft.waxed_cut_copper": "გაცვილული მოჭრილი სპილენძი",
  "block.minecraft.waxed_cut_copper_slab": "გაცვილული მოჭრილი სპილენძის ფილა",
  "block.minecraft.waxed_cut_copper_stairs": "გაცვილული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.waxed_exposed_chiseled_copper": "გაცვილული გამუქებული მოჩუქურთმებული სპილენძი",
  "block.minecraft.waxed_exposed_copper": "გაცვილული გამუქებული სპილენძი",
  "block.minecraft.waxed_exposed_copper_bars": "გაცვილული გამუქებული სპილენძის გისოსები",
  "block.minecraft.waxed_exposed_copper_bulb": "გაცვილული გამუქებული სპილენძის ნათურა",
  "block.minecraft.waxed_exposed_copper_chain": "გაცვილული გამუქებული სპილენძის ჯაჭვი",
  "block.minecraft.waxed_exposed_copper_chest": "გაცვილული გამუქებული სპილენძის სკივრი",
  "block.minecraft.waxed_exposed_copper_door": "გაცვილული გამუქებული სპილენძის კარი",
  "block.minecraft.waxed_exposed_copper_golem_statue": "გაცვილული გამუქებული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.waxed_exposed_copper_grate": "გაცვილული გამუქებული სპილენძის ცხაურა",
  "block.minecraft.waxed_exposed_copper_lantern": "გაცვილული გამუქებული სპილენძის ლამპარი",
  "block.minecraft.waxed_exposed_copper_trapdoor": "გაცვილული გამუქებული სპილენძის სარკმელი",
  "block.minecraft.waxed_exposed_cut_copper": "გაცვილული გამუქებული მოჭრილი სპილენძი",
  "block.minecraft.waxed_exposed_cut_copper_slab": "გაცვილული გამუქებული მოჭრილი სპილენძის ფილა",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "გაცვილული გამუქებული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.waxed_exposed_lightning_rod": "გაცვილული გამუქებული მეხამრიდი",
  "block.minecraft.waxed_lightning_rod": "გაცვილული მეხამრიდი",
  "block.minecraft.waxed_oxidized_chiseled_copper": "გაცვილული დაჟანგული მოჩუქურთმებული სპილენძი",
  "block.minecraft.waxed_oxidized_copper": "გაცვილული დაჟანგული სპილენძი",
  "block.minecraft.waxed_oxidized_copper_bars": "გაცვილული დაჟანგული სპილენძის გისოსები",
  "block.minecraft.waxed_oxidized_copper_bulb": "გაცვილული დაჟანგული სპილენძის ნათურა",
  "block.minecraft.waxed_oxidized_copper_chain": "გაცვილული დაჟანგული სპილენძის ჯაჭვი",
  "block.minecraft.waxed_oxidized_copper_chest": "გაცვილული დაჟანგული სპილენძის სკივრი",
  "block.minecraft.waxed_oxidized_copper_door": "გაცვილული დაჟანგული სპილენძის კარი",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "გაცვილული დაჟანგული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.waxed_oxidized_copper_grate": "გაცვილული დაჟანგული სპილენძის ცხაურა",
  "block.minecraft.waxed_oxidized_copper_lantern": "გაცვილული დაჟანგული სპილენძის ლამპარი",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "გაცვილული დაჟანგული სპილენძის სარკმელი",
  "block.minecraft.waxed_oxidized_cut_copper": "გაცვილული დაჟანგული მოჭრილი სპილენძი",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "გაცვილული დაჟანგული მოჭრილი სპილენძის ფილა",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "გაცვილული დაჟანგული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.waxed_oxidized_lightning_rod": "გაცვილული დაჟანგული მეხამრიდი",
  "block.minecraft.waxed_weathered_chiseled_copper": "გაცვილული დაძველებული მოჩუქურთმებული სპილენძი",
  "block.minecraft.waxed_weathered_copper": "გაცვილული დაძველებული სპილენძი",
  "block.minecraft.waxed_weathered_copper_bars": "გაცვილული დაძველებული სპილენძის გისოსები",
  "block.minecraft.waxed_weathered_copper_bulb": "გაცვილული დაძველებული სპილენძის ნათურა",
  "block.minecraft.waxed_weathered_copper_chain": "გაცვილული დაძველებული სპილენძის ჯაჭვი",
  "block.minecraft.waxed_weathered_copper_chest": "გაცვილული დაძველებული სპილენძის სკივრი",
  "block.minecraft.waxed_weathered_copper_door": "გაცვილული დაძველებული სპილენძის კარი",
  "block.minecraft.waxed_weathered_copper_golem_statue": "გაცვილული დაძველებული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.waxed_weathered_copper_grate": "გაცვილული დაძველებული სპილენძის ცხაურა",
  "block.minecraft.waxed_weathered_copper_lantern": "გაცვილული დაძველებული სპილენძის ლამპარი",
  "block.minecraft.waxed_weathered_copper_trapdoor": "გაცვილული დაძველებული სპილენძის სარკმელი",
  "block.minecraft.waxed_weathered_cut_copper": "გაცვილული დაძველებული მოჭრილი სპილენძი",
  "block.minecraft.waxed_weathered_cut_copper_slab": "გაცვილული დაძველებული მოჭრილი სპილენძის ფილა",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "გაცვილული დაძველებული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.waxed_weathered_lightning_rod": "გაცვილული დაძველებული მეხამრიდი",
  "block.minecraft.weathered_chiseled_copper": "დაძველებული მოჩუქურთმებული სპილენძი",
  "block.minecraft.weathered_copper": "დაძველებული სპილენძი",
  "block.minecraft.weathered_copper_bars": "დაძველებული სპილენძის გისოსები",
  "block.minecraft.weathered_copper_bulb": "დაძველებული სპილენძის ნათურა",
  "block.minecraft.weathered_copper_chain": "დაძველებული სპილენძის ჯაჭვი",
  "block.minecraft.weathered_copper_chest": "დაძველებული სპილენძის სკივრი",
  "block.minecraft.weathered_copper_door": "დაძველებული სპილენძის კარი",
  "block.minecraft.weathered_copper_golem_statue": "დაძველებული სპილენძის გოლემის ქანდაკება",
  "block.minecraft.weathered_copper_grate": "დაძველებული სპილენძის ცხაურა",
  "block.minecraft.weathered_copper_lantern": "დაძველებული სპილენძის ლამპარი",
  "block.minecraft.weathered_copper_trapdoor": "დაძველებული სპილენძის სარკმელი",
  "block.minecraft.weathered_cut_copper": "დაძველებული მოჭრილი სპილენძი",
  "block.minecraft.weathered_cut_copper_slab": "დაძველებული მოჭრილი სპილენძის ფილა",
  "block.minecraft.weathered_cut_copper_stairs": "დაძველებული მოჭრილი სპილენძის საფეხურები",
  "block.minecraft.weathered_lightning_rod": "დაძველებული მეხამრიდი",
  "block.minecraft.weeping_vines": "მტირალი სურო",
  "block.minecraft.weeping_vines_plant": "მტირალი სუროს ღერო",
  "block.minecraft.wet_sponge": "სველი ღრუბელი",
  "block.minecraft.wheat": "ხორბლის თავები",
  "block.minecraft.white_banner": "თეთრი დროშა",
  "block.minecraft.white_bed": "თეთრი საწოლი",
  "block.minecraft.white_candle": "თეთრი სანთელი",
  "block.minecraft.white_candle_cake": "ტორტი თეთრი სანთლით",
  "block.minecraft.white_carpet": "თეთრი ხალიჩა",
  "block.minecraft.white_concrete": "თეთრი ბეტონი",
  "block.minecraft.white_concrete_powder": "თეთრი ცემენტი",
  "block.minecraft.white_glazed_terracotta": "თეთრი მოჭიქული ტერაკოტა",
  "block.minecraft.white_shulker_box": "თეთრი შალკერ-ყუთი",
  "block.minecraft.white_stained_glass": "თეთრი შუშა",
  "block.minecraft.white_stained_glass_pane": "თეთრი მინა",
  "block.minecraft.white_terracotta": "თეთრი ტერაკოტა",
  "block.minecraft.white_tulip": "თეთრი ტიტა",
  "block.minecraft.white_wool": "თეთრი მატყლი",
  "block.minecraft.wildflowers": "ველური ყვავილები",
  "block.minecraft.wither_rose": "ვიზერის ვარდი",
  "block.minecraft.wither_skeleton_skull": "ვიზერ-ჩონჩხის თავის ქალა",
  "block.minecraft.wither_skeleton_wall_skull": "ვიზერ-ჩონჩხის კედლის თავის ქალა",
  "block.minecraft.yellow_banner": "ყვითელი დროშა",
  "block.minecraft.yellow_bed": "ყვითელი საწოლი",
  "block.minecraft.yellow_candle": "ყვითელი სანთელი",
  "block.minecraft.yellow_candle_cake": "ტორტი ყვითელი სანთლით",
  "block.minecraft.yellow_carpet": "ყვითელი ხალიჩა",
  "block.minecraft.yellow_concrete": "ყვითელი ბეტონი",
  "block.minecraft.yellow_concrete_powder": "ყვითელი ცემენტი",
  "block.minecraft.yellow_glazed_terracotta": "ყვითელი მოჭიქული ტერაკოტა",
  "block.minecraft.yellow_shulker_box": "ყვითელი შალკერ-ყუთი",
  "block.minecraft.yellow_stained_glass": "ყვითელი შუშა",
  "block.minecraft.yellow_stained_glass_pane": "ყვითელი მინა",
  "block.minecraft.yellow_terracotta": "ყვითელი ტერაკოტა",
  "block.minecraft.yellow_wool": "ყვითელი მატყლი",
  "block.minecraft.zombie_head": "ზომბის თავი",
  "block.minecraft.zombie_wall_head": "ზომბის კედლის თავი",
  "item.minecraft.acacia_boat": "აკაციის ნავი",
  "item.minecraft.acacia_chest_boat": "სკივრიანი აკაციის ნავი",
  "item.minecraft.allay_spawn_egg": "დუმილას გამოძახების კვერცხი",
  "item.minecraft.amethyst_shard": "ამეთვისტოს ნატეხი",
  "item.minecraft.angler_pottery_shard": "ჭურჭლის ნატეხი – მეთევზე",
  "item.minecraft.angler_pottery_sherd": "ჭურჭლის ნატეხი – მეთევზე",
  "item.minecraft.apple": "ვაშლი",
  "item.minecraft.archer_pottery_shard": "ჭურჭლის ნატეხი – მშვილდოსანი",
  "item.minecraft.archer_pottery_sherd": "ჭურჭლის ნატეხი – მშვილდოსანი",
  "item.minecraft.armadillo_scute": "ჯავშნოსნის ფირფიტა",
  "item.minecraft.armadillo_spawn_egg": "ჯავშნოსნის გამოძახების კვერცხი",
  "item.minecraft.armor_stand": "აბჯრის სადგამი",
  "item.minecraft.arms_up_pottery_shard": "ჭურჭლის ნატეხი – ხელები მაღლა",
  "item.minecraft.arms_up_pottery_sherd": "ჭურჭლის ნატეხი – ხელები მაღლა",
  "item.minecraft.arrow": "ისარი",
  "item.minecraft.axolotl_bucket": "აქსოლოტლი სათლში",
  "item.minecraft.axolotl_spawn_egg": "აქსოლოტლის გამოძახების კვერცხი",
  "item.minecraft.baked_potato": "გამომცხვარი კარტოფილი",
  "item.minecraft.bamboo_chest_raft": "სკივრიანი ბამბუკის ტივი",
  "item.minecraft.bamboo_raft": "ბამბუკის ტივი",
  "item.minecraft.bat_spawn_egg": "ღამურას გამოძახების კვერცხი",
  "item.minecraft.bee_spawn_egg": "ფუტკრის გამოძახების კვერცხი",
  "item.minecraft.beef": "უმი საქონლის ხორცი",
  "item.minecraft.beetroot": "ჭარხალი",
  "item.minecraft.beetroot_seeds": "ჭარხლის თესლი",
  "item.minecraft.beetroot_soup": "ჭარხლის წვნიანი",
  "item.minecraft.birch_boat": "არყის ნავი",
  "item.minecraft.birch_chest_boat": "სკივრიანი არყის ნავი",
  "item.minecraft.black_bundle": "შავი ტომარა",
  "item.minecraft.black_dye": "შავი საღებავი",
  "item.minecraft.black_harness": "შავი აკაზმულობა",
  "item.minecraft.blade_pottery_shard": "ჭურჭლის ნატეხი – მახვილი",
  "item.minecraft.blade_pottery_sherd": "ჭურჭლის ნატეხი – მახვილი",
  "item.minecraft.blaze_powder": "ცეცხლოვანი ფხვნილი",
  "item.minecraft.blaze_rod": "გიზღალას ღერძი",
  "item.minecraft.blaze_spawn_egg": "გიზღალას გამოძახების კვერცხი",
  "item.minecraft.blue_bundle": "ლურჯი ტომარა",
  "item.minecraft.blue_dye": "ლურჯი საღებავი",
  "item.minecraft.blue_egg": "ცისფერი კვერცხი",
  "item.minecraft.blue_harness": "ლურჯი აკაზმულობა",
  "item.minecraft.bogged_spawn_egg": "დაჭაობებულის გამოძახების კვერცხი",
  "item.minecraft.bolt_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „ხრახნი“",
  "item.minecraft.bone": "ძვალი",
  "item.minecraft.bone_meal": "ძვლის ფხვნილი",
  "item.minecraft.book": "წიგნი",
  "item.minecraft.bordure_indented_banner_pattern": "დროშის მოხატულობა „დაკბილული არშია“",
  "item.minecraft.bow": "მშვილდი",
  "item.minecraft.bowl": "ჯამი",
  "item.minecraft.bread": "პური",
  "item.minecraft.breeze_rod": "ქარბორბალას ღერძი",
  "item.minecraft.breeze_spawn_egg": "ქარბორბალას გამოძახების კვერცხი",
  "item.minecraft.brewer_pottery_shard": "ჭურჭლის ნატეხი – მეხსნარე",
  "item.minecraft.brewer_pottery_sherd": "ჭურჭლის ნატეხი – მეხსნარე",
  "item.minecraft.brewing_stand": "ხსნარსახარში",
  "item.minecraft.brick": "აგური",
  "item.minecraft.brown_bundle": "ყავისფერი ტომარა",
  "item.minecraft.brown_dye": "ყავისფერი საღებავი",
  "item.minecraft.brown_egg": "ყავისფერი კვერცხი",
  "item.minecraft.brown_harness": "ყავისფერი აკაზმულობა",
  "item.minecraft.brush": "ფუნჯი",
  "item.minecraft.bucket": "სათლი",
  "item.minecraft.bundle": "ტომარა",
  "item.minecraft.bundle.empty": "ცარიელია",
  "item.minecraft.bundle.empty.description": "შეუძლია მოიცავდეს სტაკ სხვადასხვა ნივთს",
  "item.minecraft.bundle.full": "სავსეა",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "ჭურჭლის ნატეხი – ალი",
  "item.minecraft.burn_pottery_sherd": "ჭურჭლის ნატეხი – ალი",
  "item.minecraft.camel_husk_spawn_egg": "აქლემ-ხმელას გამოძახების კვერცხი",
  "item.minecraft.camel_spawn_egg": "აქლემის გამოძახების კვერცხი",
  "item.minecraft.carrot": "სტაფილო",
  "item.minecraft.carrot_on_a_stick": "სტაფილო ანკესზე",
  "item.minecraft.cat_spawn_egg": "კატის გამოძახების კვერცხი",
  "item.minecraft.cauldron": "ქვაბი",
  "item.minecraft.cave_spider_spawn_egg": "გამოქვაბულის ობობის გამოძახების კვერცხი",
  "item.minecraft.chainmail_boots": "ჯაჭვის ფეხსაცმელი",
  "item.minecraft.chainmail_chestplate": "ჯაჭვის პერანგი",
  "item.minecraft.chainmail_helmet": "ჯაჭვის მუზარადი",
  "item.minecraft.chainmail_leggings": "ჯაჭვის შარვალი",
  "item.minecraft.charcoal": "ნახშირი",
  "item.minecraft.cherry_boat": "ალუბლის ნავი",
  "item.minecraft.cherry_chest_boat": "სკივრიანი ალუბლის ნავი",
  "item.minecraft.chest_minecart": "სკივრიანი ურიკა",
  "item.minecraft.chicken": "უმი ქათამი",
  "item.minecraft.chicken_spawn_egg": "ქათმის გამოძახების კვერცხი",
  "item.minecraft.chorus_fruit": "ქორუსის ნაყოფი",
  "item.minecraft.clay_ball": "თიხის ბურთი",
  "item.minecraft.clock": "საათი",
  "item.minecraft.coal": "ქვანახშირი",
  "item.minecraft.coast_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.coast_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „სანაპირო“",
  "item.minecraft.cocoa_beans": "კაკაოს მარცვლები",
  "item.minecraft.cod": "უმი ვირთევზა",
  "item.minecraft.cod_bucket": "ვირთევზა სათლში",
  "item.minecraft.cod_spawn_egg": "ვირთევზას გამოძახების კვერცხი",
  "item.minecraft.command_block_minecart": "ბრძანების ბლოკიანი ურიკა",
  "item.minecraft.compass": "კომპასი",
  "item.minecraft.cooked_beef": "შემწვარი საქონლის ხორცი",
  "item.minecraft.cooked_chicken": "შემწვარი ქათამი",
  "item.minecraft.cooked_cod": "შემწვარი ვირთევზა",
  "item.minecraft.cooked_mutton": "შემწვარი ცხვრის ხორცი",
  "item.minecraft.cooked_porkchop": "შემწვარი ღორის ხორცი",
  "item.minecraft.cooked_rabbit": "შემწვარი კურდღელი",
  "item.minecraft.cooked_salmon": "შემწვარი ორაგული",
  "item.minecraft.cookie": "ნამცხვარი",
  "item.minecraft.copper_axe": "სპილენძის ნაჯახი",
  "item.minecraft.copper_boots": "სპილენძის ფეხსაცმელი",
  "item.minecraft.copper_chestplate": "სპილენძის პერანგი",
  "item.minecraft.copper_golem_spawn_egg": "სპილენძის გოლემის გამოძახების კვერცხი",
  "item.minecraft.copper_helmet": "სპილენძის მუზარადი",
  "item.minecraft.copper_hoe": "სპილენძის თოხი",
  "item.minecraft.copper_horse_armor": "ცხენის სპილენძის აბჯარი",
  "item.minecraft.copper_ingot": "სპილენძის ზოდი",
  "item.minecraft.copper_leggings": "სპილენძის შარვალი",
  "item.minecraft.copper_nautilus_armor": "ნაუტილუსის სპილენძის აბჯარი",
  "item.minecraft.copper_nugget": "სპილენძის ნატეხი",
  "item.minecraft.copper_pickaxe": "სპილენძის წერაქვი",
  "item.minecraft.copper_shovel": "სპილენძის ნიჩაბი",
  "item.minecraft.copper_spear": "სპილენძის შუბი",
  "item.minecraft.copper_sword": "სპილენძის ხმალი",
  "item.minecraft.cow_spawn_egg": "ძროხის გამოძახების კვერცხი",
  "item.minecraft.creaking_spawn_egg": "ჭრიალას გამოძახების კვერცხი",
  "item.minecraft.creeper_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.creeper_banner_pattern.desc": "კრიპერის ფიგურა",
  "item.minecraft.creeper_banner_pattern.new": "დროშის მოხატულობა „კრიპერის სახე“",
  "item.minecraft.creeper_spawn_egg": "კრიპერის გამოძახების კვერცხი",
  "item.minecraft.crossbow": "არბალეტი",
  "item.minecraft.crossbow.projectile": "ჭურვი:",
  "item.minecraft.crossbow.projectile.multiple": "ჭურვი: %s x %s",
  "item.minecraft.crossbow.projectile.single": "ჭურვი: %s",
  "item.minecraft.cyan_bundle": "ფირუზისფერი ტომარა",
  "item.minecraft.cyan_dye": "ფირუზისფერი საღებავი",
  "item.minecraft.cyan_harness": "ფირუზისფერი აკაზმულობა",
  "item.minecraft.danger_pottery_shard": "ჭურჭლის ნატეხი „საფრთხე“",
  "item.minecraft.danger_pottery_sherd": "ჭურჭლის ნატეხი – საფრთხე",
  "item.minecraft.dark_oak_boat": "მუქი მუხის ნავი",
  "item.minecraft.dark_oak_chest_boat": "სკივრიანი მუქი მუხის ნავი",
  "item.minecraft.debug_stick": "სწორების ჯოხი",
  "item.minecraft.debug_stick.empty": "%s არ შეიცავს თვისებებს",
  "item.minecraft.debug_stick.select": "არჩეულია „%s“ (%s)",
  "item.minecraft.debug_stick.update": "„%s“: %s",
  "item.minecraft.diamond": "ალმასი",
  "item.minecraft.diamond_axe": "ალმასის ნაჯახი",
  "item.minecraft.diamond_boots": "ალმასის ფეხსაცმელი",
  "item.minecraft.diamond_chestplate": "ალმასის პერანგი",
  "item.minecraft.diamond_helmet": "ალმასის მუზარადი",
  "item.minecraft.diamond_hoe": "ალმასის თოხი",
  "item.minecraft.diamond_horse_armor": "ცხენის ალმასის აბჯარი",
  "item.minecraft.diamond_leggings": "ალმასის შარვალი",
  "item.minecraft.diamond_nautilus_armor": "ნაუტილუსის ალმასის აბჯარი",
  "item.minecraft.diamond_pickaxe": "ალმასის წერაქვი",
  "item.minecraft.diamond_shovel": "ალმასის ნიჩაბი",
  "item.minecraft.diamond_spear": "ალმასის შუბი",
  "item.minecraft.diamond_sword": "ალმასის ხმალი",
  "item.minecraft.disc_fragment_5": "დისკის ნატეხი",
  "item.minecraft.disc_fragment_5.desc": "მუსიკალური დისკი — 5",
  "item.minecraft.dolphin_spawn_egg": "დელფინის გამოძახების კვერცხი",
  "item.minecraft.donkey_spawn_egg": "ვირის გამოძახების კვერცხი",
  "item.minecraft.dragon_breath": "დრაკონის სუნთქვა",
  "item.minecraft.dried_kelp": "გამომშრალი ლამინარია",
  "item.minecraft.drowned_spawn_egg": "ხრჩობილის გამოძახების კვერცხი",
  "item.minecraft.dune_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.dune_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „დიუნი“",
  "item.minecraft.echo_shard": "ექოს ნატეხი",
  "item.minecraft.egg": "კვერცხი",
  "item.minecraft.elder_guardian_spawn_egg": "ძველი მცველის გამოძახების კვერცხი",
  "item.minecraft.elytra": "ელიტრები",
  "item.minecraft.emerald": "ზურმუხტი",
  "item.minecraft.enchanted_book": "მოჯადოებული წიგნი",
  "item.minecraft.enchanted_golden_apple": "მოჯადოებული ოქროს ვაშლი",
  "item.minecraft.end_crystal": "ენდის კრისტალი",
  "item.minecraft.ender_dragon_spawn_egg": "ენდერ-დრაკონის გამოძახების კვერცხი",
  "item.minecraft.ender_eye": "ენდერის თვალი",
  "item.minecraft.ender_pearl": "ენდერ-მარგალიტი",
  "item.minecraft.enderman_spawn_egg": "ენდერმენის გამოძახების კვერცხი",
  "item.minecraft.endermite_spawn_egg": "ენდერმიტის გამოძახების კვერცხი",
  "item.minecraft.evoker_spawn_egg": "შემლოცველის გამოძახების კვერცხი",
  "item.minecraft.experience_bottle": "მოჯადოებული ბოთლი",
  "item.minecraft.explorer_pottery_shard": "ჭურჭლის ნატეხი – მკვლევარი",
  "item.minecraft.explorer_pottery_sherd": "ჭურჭლის ნატეხი – მკვლევარი",
  "item.minecraft.eye_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.eye_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „თვალი“",
  "item.minecraft.feather": "ბუმბული",
  "item.minecraft.fermented_spider_eye": "დამწნილებული ობობის თვალი",
  "item.minecraft.field_masoned_banner_pattern": "დროშის მოხატულობა „აგურები“",
  "item.minecraft.filled_map": "რუკა",
  "item.minecraft.fire_charge": "ცეცხლოვანი ბურთი",
  "item.minecraft.firework_rocket": "მაშხალა",
  "item.minecraft.firework_rocket.flight": "ფრენის ხანგრძლივობა:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "მაშხალის ვარსკლავი",
  "item.minecraft.firework_star.black": "შავი",
  "item.minecraft.firework_star.blue": "ლურჯი",
  "item.minecraft.firework_star.brown": "ყავისფერი",
  "item.minecraft.firework_star.custom_color": "მორგებული",
  "item.minecraft.firework_star.cyan": "ფირუზისფერი",
  "item.minecraft.firework_star.fade_to": "გადასვლა ფერში ",
  "item.minecraft.firework_star.flicker": "კაშკაში",
  "item.minecraft.firework_star.gray": "ნაცრისფერი",
  "item.minecraft.firework_star.green": "მწვანე",
  "item.minecraft.firework_star.light_blue": "ცისფერი",
  "item.minecraft.firework_star.light_gray": "ღია ნაცრისფერი",
  "item.minecraft.firework_star.lime": "სალათისფერი",
  "item.minecraft.firework_star.magenta": "იასამნისფერი",
  "item.minecraft.firework_star.orange": "ნარინჯისფერი",
  "item.minecraft.firework_star.pink": "ვარდისფერი",
  "item.minecraft.firework_star.purple": "იისფერი",
  "item.minecraft.firework_star.red": "წითელი",
  "item.minecraft.firework_star.shape": "უცნობი ფორმა",
  "item.minecraft.firework_star.shape.burst": "აფეთქება",
  "item.minecraft.firework_star.shape.creeper": "კრიპერის ფორმის",
  "item.minecraft.firework_star.shape.large_ball": "დიდი ბურთი",
  "item.minecraft.firework_star.shape.small_ball": "პატარა ბურთი",
  "item.minecraft.firework_star.shape.star": "ვარსკვლავის ფორმის",
  "item.minecraft.firework_star.trail": "კვალი",
  "item.minecraft.firework_star.white": "თეთრი",
  "item.minecraft.firework_star.yellow": "ყვითელი",
  "item.minecraft.fishing_rod": "სათევზაო ანკესი",
  "item.minecraft.flint": "კაჟი",
  "item.minecraft.flint_and_steel": "კვესი",
  "item.minecraft.flow_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.flow_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „ნაკადი“",
  "item.minecraft.flow_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.flow_banner_pattern.desc": "ნაკადი",
  "item.minecraft.flow_banner_pattern.new": "დროშის მოხატულობა „ნაკადი“",
  "item.minecraft.flow_pottery_sherd": "ჭურჭლის ნატეხი – ნაკადი",
  "item.minecraft.flower_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.flower_banner_pattern.desc": "ყვავილი",
  "item.minecraft.flower_banner_pattern.new": "დროშის მოხატულობა „ყვავილი“",
  "item.minecraft.flower_pot": "ყვავილის ქოთანი",
  "item.minecraft.fox_spawn_egg": "მელიის გამოძახების კვერცხი",
  "item.minecraft.friend_pottery_shard": "ჭურჭლის ნატეხი – მეგობარი",
  "item.minecraft.friend_pottery_sherd": "ჭურჭლის ნატეხი – მეგობარი",
  "item.minecraft.frog_spawn_egg": "ბაყაყის გამოძახების კვერცხი",
  "item.minecraft.furnace_minecart": "ღუმლიანი ურიკა",
  "item.minecraft.ghast_spawn_egg": "გასტის გამოძახების კვერცხი",
  "item.minecraft.ghast_tear": "გასტის ცრემლი",
  "item.minecraft.glass_bottle": "შუშის ბოთლი",
  "item.minecraft.glistering_melon_slice": "ბრჭყვიალა საზამთროს ნაჭერი",
  "item.minecraft.globe_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.globe_banner_pattern.desc": "გლობუსი",
  "item.minecraft.globe_banner_pattern.new": "დროშის მოხატულობა „გლობუსი“",
  "item.minecraft.glow_berries": "მნათობი კენკრა",
  "item.minecraft.glow_ink_sac": "მნათობი მელნის ტომარა",
  "item.minecraft.glow_item_frame": "მნათობი ჩარჩო",
  "item.minecraft.glow_squid_spawn_egg": "მნათობი კალმარის გამოძახების კვერცხი",
  "item.minecraft.glowstone_dust": "ნათობქვის მტვერი",
  "item.minecraft.goat_horn": "თხის რქა",
  "item.minecraft.goat_spawn_egg": "თხის გამოძახების კვერცხი",
  "item.minecraft.gold_ingot": "ოქროს ზოდი",
  "item.minecraft.gold_nugget": "ოქროს ნატეხი",
  "item.minecraft.golden_apple": "ოქროს ვაშლი",
  "item.minecraft.golden_axe": "ოქროს ნაჯახი",
  "item.minecraft.golden_boots": "ოქროს ფეხსაცმელი",
  "item.minecraft.golden_carrot": "ოქროს სტაფილო",
  "item.minecraft.golden_chestplate": "ოქროს პერანგი",
  "item.minecraft.golden_helmet": "ოქროს მუზარადი",
  "item.minecraft.golden_hoe": "ოქროს თოხი",
  "item.minecraft.golden_horse_armor": "ცხენის ოქროს აბჯარი",
  "item.minecraft.golden_leggings": "ოქროს შარვალი",
  "item.minecraft.golden_nautilus_armor": "ნაუტილუსის ოქროს აბჯარი",
  "item.minecraft.golden_pickaxe": "ოქროს წერაქვი",
  "item.minecraft.golden_shovel": "ოქროს ნიჩაბი",
  "item.minecraft.golden_spear": "ოქროს შუბი",
  "item.minecraft.golden_sword": "ოქროს ხმალი",
  "item.minecraft.gray_bundle": "ნაცრისფერი ტომარა",
  "item.minecraft.gray_dye": "ნაცრისფერი საღებავი",
  "item.minecraft.gray_harness": "ნაცრისფერი აკაზმულობა",
  "item.minecraft.green_bundle": "მწვანე ტომარა",
  "item.minecraft.green_dye": "მწვანე საღებავი",
  "item.minecraft.green_harness": "მწვანე აკაზმულობა",
  "item.minecraft.guardian_spawn_egg": "მცველის გამოძახების კვერცხი",
  "item.minecraft.gunpowder": "დენთი",
  "item.minecraft.guster_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.guster_banner_pattern.desc": "ქარბორბალა",
  "item.minecraft.guster_banner_pattern.new": "დროშის მოხატულობა „ქარბორბალა“",
  "item.minecraft.guster_pottery_sherd": "ჭურჭლის ნატეხი – ქარბორბალა",
  "item.minecraft.happy_ghast_spawn_egg": "ლაღი გასტის გამოძახების კვერცხი",
  "item.minecraft.harness": "აკაზმულობა",
  "item.minecraft.heart_of_the_sea": "ზღვის გული",
  "item.minecraft.heart_pottery_shard": "ჭურჭლის ნატეხი – გული",
  "item.minecraft.heart_pottery_sherd": "ჭურჭლის ნატეხი – გული",
  "item.minecraft.heartbreak_pottery_shard": "ჭურჭლის ნატეხი – გატეხილი გული",
  "item.minecraft.heartbreak_pottery_sherd": "ჭურჭლის ნატეხი – გატეხილი გული",
  "item.minecraft.hoglin_spawn_egg": "ჰოგლინის გამოძახების კვერცხი",
  "item.minecraft.honey_bottle": "თაფლიანი ბოთლი",
  "item.minecraft.honeycomb": "ფიჭა",
  "item.minecraft.hopper_minecart": "ძაბრიანი ურიკა",
  "item.minecraft.horse_spawn_egg": "ცხენის გამოძახების კვერცხი",
  "item.minecraft.host_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.host_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „მასპინძელი“",
  "item.minecraft.howl_pottery_shard": "ჭურჭლის ნატეხი „ღმუილი“",
  "item.minecraft.howl_pottery_sherd": "ჭურჭლის ნატეხი – ღმუილი",
  "item.minecraft.husk_spawn_egg": "ხმელას გამოძახების კვერცხი",
  "item.minecraft.ink_sac": "მელნიანი ტომარა",
  "item.minecraft.iron_axe": "რკინის ნაჯახი",
  "item.minecraft.iron_boots": "რკინის ფეხსაცმელი",
  "item.minecraft.iron_chestplate": "რკინის პერანგი",
  "item.minecraft.iron_golem_spawn_egg": "რკინის გოლემის გამოძახების კვერცხი",
  "item.minecraft.iron_helmet": "რკინის მუზარადი",
  "item.minecraft.iron_hoe": "რკინის თოხი",
  "item.minecraft.iron_horse_armor": "ცხენის რკინის აბჯარი",
  "item.minecraft.iron_ingot": "რკინის ზოდი",
  "item.minecraft.iron_leggings": "რკინის შარვალი",
  "item.minecraft.iron_nautilus_armor": "ნაუტილუსის რკინის აბჯარი",
  "item.minecraft.iron_nugget": "რკინის ნატეხი",
  "item.minecraft.iron_pickaxe": "რკინის წერაქვი",
  "item.minecraft.iron_shovel": "რკინის ნიჩაბი",
  "item.minecraft.iron_spear": "რკინის შუბი",
  "item.minecraft.iron_sword": "რკინის ხმალი",
  "item.minecraft.item_frame": "ჩარჩო",
  "item.minecraft.jungle_boat": "ტროპიკული ხის ნავი",
  "item.minecraft.jungle_chest_boat": "სკივრიანი ტროპიკული ხის ნავი",
  "item.minecraft.knowledge_book": "ცოდნის წიგნი",
  "item.minecraft.lapis_lazuli": "ლილაქვა",
  "item.minecraft.lava_bucket": "ლავიანი სათლი",
  "item.minecraft.lead": "სადავე",
  "item.minecraft.leather": "ტყავი",
  "item.minecraft.leather_boots": "ტყავის ფეხსაცმელი",
  "item.minecraft.leather_chestplate": "ტყავის ქურთუკი",
  "item.minecraft.leather_helmet": "ტყავის ქუდი",
  "item.minecraft.leather_horse_armor": "ცხენის ტყავის აბჯარი",
  "item.minecraft.leather_leggings": "ტყავის შარვალი",
  "item.minecraft.light_blue_bundle": "ცისფერი ტომარა",
  "item.minecraft.light_blue_dye": "ცისფერი საღებავი",
  "item.minecraft.light_blue_harness": "ცისფერი აკაზმულობა",
  "item.minecraft.light_gray_bundle": "ღია ნაცრისფერი ტომარა",
  "item.minecraft.light_gray_dye": "ღია ნაცრისფერი საღებავი",
  "item.minecraft.light_gray_harness": "ღია ნაცრისფერი აკაზმულობა",
  "item.minecraft.lime_bundle": "სალათისფერი ტომარა",
  "item.minecraft.lime_dye": "სალათისფერი საღებავი",
  "item.minecraft.lime_harness": "სალათისფერი აკაზმულობა",
  "item.minecraft.lingering_potion": "ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.awkward": "არეული ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.empty": "შეუქმნადი ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.fire_resistance": "ცეცხლმედეგობის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.harming": "ზიანის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.healing": "მკურნალობის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.infested": "დაავადების ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.invisibility": "უჩინარობის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.leaping": "ხტომის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.levitation": "ლევიტაციის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.luck": "იღბლიანობის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.mundane": "მდარე ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.night_vision": "ღამე ხედვის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.oozing": "ლორწოების ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.poison": "მოწამლვის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.regeneration": "რეგენერაციის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.slow_falling": "სიმსუბუქის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.slowness": "შენელების ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.strength": "სიძლიერის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.swiftness": "სისწრაფის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.thick": "სქელი ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.turtle_master": "კუს ოსტატობის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.water": "ხანგრძლივი წყლის ბოთლი",
  "item.minecraft.lingering_potion.effect.water_breathing": "წყალში სუნთვის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.weakness": "სისუსტის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.weaving": "ქსოვის ხანგრძლივი ხსნარი",
  "item.minecraft.lingering_potion.effect.wind_charged": "ქარიანობის ხანგრძლივი ხსნარი",
  "item.minecraft.llama_spawn_egg": "ლამის გამოძახების კვერცხი",
  "item.minecraft.lodestone_compass": "მიმაგნიტებული კომპასი",
  "item.minecraft.mace": "გურზი",
  "item.minecraft.magenta_bundle": "იასამნისფერი ტომარა",
  "item.minecraft.magenta_dye": "იასამნისფერი საღებავი",
  "item.minecraft.magenta_harness": "იასამნისფერი აკაზმულობა",
  "item.minecraft.magma_cream": "მაგმის კრემი",
  "item.minecraft.magma_cube_spawn_egg": "მაგმა-კუბის გამოძახების კვერცხი",
  "item.minecraft.mangrove_boat": "მანგროვის ნავი",
  "item.minecraft.mangrove_chest_boat": "სკივრიანი მანგროვის ნავი",
  "item.minecraft.map": "ცარიელი რუკა",
  "item.minecraft.melon_seeds": "საზამთროს თესლი",
  "item.minecraft.melon_slice": "საზამთროს ნაჭერი",
  "item.minecraft.milk_bucket": "რძიანი სათლი",
  "item.minecraft.minecart": "ურიკა",
  "item.minecraft.miner_pottery_shard": "ჭურჭლის ნატეხი – მაღაროელი",
  "item.minecraft.miner_pottery_sherd": "ჭურჭლის ნატეხი – მაღაროელი",
  "item.minecraft.mojang_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.mojang_banner_pattern.desc": "რაღაც",
  "item.minecraft.mojang_banner_pattern.new": "დროშის მოხატულობა „რაღაც“",
  "item.minecraft.mooshroom_spawn_egg": "მუშრუმის გამოძახების კვერცხი",
  "item.minecraft.mourner_pottery_shard": "ჭურჭლის ნატეხი – მგლოვიარე",
  "item.minecraft.mourner_pottery_sherd": "ჭურჭლის ნატეხი – მგლოვიარე",
  "item.minecraft.mule_spawn_egg": "ჯორის გამოძახების კვერცხი",
  "item.minecraft.mushroom_stew": "მოშუშული სოკო",
  "item.minecraft.music_disc_11": "მუსიკალური დისკი",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "მუსიკალური დისკი",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "მუსიკალური დისკი",
  "item.minecraft.music_disc_5.desc": "სამუელ ობერგი — 5",
  "item.minecraft.music_disc_blocks": "მუსიკალური დისკი",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "მუსიკალური დისკი",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "მუსიკალური დისკი",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "მუსიკალური დისკი",
  "item.minecraft.music_disc_creator.desc": "ლენა რეინი — Creator",
  "item.minecraft.music_disc_creator_music_box": "მუსიკალური დისკი",
  "item.minecraft.music_disc_creator_music_box.desc": "ლენა რეინი — Creator (მუსიკალური ყუთი)",
  "item.minecraft.music_disc_far": "მუსიკალური დისკი",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "მუსიკალური დისკი",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "მუსიკალური დისკი",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "მუსიკალური დისკი",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "მუსიკალური დისკი",
  "item.minecraft.music_disc_otherside.desc": "ლენა რეინი — otherside",
  "item.minecraft.music_disc_pigstep": "მუსიკალური დისკი",
  "item.minecraft.music_disc_pigstep.desc": "ლენა რეინი — Pigstep",
  "item.minecraft.music_disc_precipice": "მუსიკალური დისკი",
  "item.minecraft.music_disc_precipice.desc": "აარონ შეროფი — Precipice",
  "item.minecraft.music_disc_relic": "მუსიკალური დისკი",
  "item.minecraft.music_disc_relic.desc": "აარონ შეროფი — Relic",
  "item.minecraft.music_disc_stal": "მუსიკალური დისკი",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "მუსიკალური დისკი",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "მუსიკალური დისკი",
  "item.minecraft.music_disc_tears.desc": "ამოს როდი — Tears",
  "item.minecraft.music_disc_wait": "მუსიკალური დისკი",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "მუსიკალური დისკი",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "უმი ცხვრის ხორცი",
  "item.minecraft.name_tag": "იარლიყი",
  "item.minecraft.nautilus_shell": "ნაუტილუსის ნიჟარა",
  "item.minecraft.nautilus_spawn_egg": "ნაუტილუსის გამოძახების კვერცხი",
  "item.minecraft.nether_brick": "ნეზერის აგური",
  "item.minecraft.nether_star": "ნეზერის ვარსკვლავი",
  "item.minecraft.nether_wart": "ნეზერის მეჭეჭა",
  "item.minecraft.netherite_axe": "ნეზერიტის ნაჯახი",
  "item.minecraft.netherite_boots": "ნეზერიტის ფეხსაცმელი",
  "item.minecraft.netherite_chestplate": "ნეზერიტის პერანგი",
  "item.minecraft.netherite_helmet": "ნეზერიტის მუზარადი",
  "item.minecraft.netherite_hoe": "ნეზერიტის თოხი",
  "item.minecraft.netherite_horse_armor": "ცხენის ნეზერიტის აბჯარი",
  "item.minecraft.netherite_ingot": "ნეზერიტის ზოდი",
  "item.minecraft.netherite_leggings": "ნეზერიტის შარვალი",
  "item.minecraft.netherite_nautilus_armor": "ნაუტილუსის ნეზერიტის აბჯარი",
  "item.minecraft.netherite_pickaxe": "ნეზერიტის წერაქვი",
  "item.minecraft.netherite_scrap": "ნეზერიტის ნატეხი",
  "item.minecraft.netherite_shovel": "ნეზერიტის ნიჩაბი",
  "item.minecraft.netherite_spear": "ნეზერიტის შუბი",
  "item.minecraft.netherite_sword": "ნეზერიტის ხმალი",
  "item.minecraft.netherite_upgrade_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.netherite_upgrade_smithing_template.new": "ნეზერიტული გაუმჯობესება",
  "item.minecraft.oak_boat": "მუხის ნავი",
  "item.minecraft.oak_chest_boat": "სკივრიანი მუხის ნავი",
  "item.minecraft.ocelot_spawn_egg": "ოცელოტის გამოძახების კვერცხი",
  "item.minecraft.ominous_bottle": "ავბედი ბოთლი",
  "item.minecraft.ominous_trial_key": "ავბედი გამოწვევების გასაღები",
  "item.minecraft.orange_bundle": "ნარინჯისფერი ტომარა",
  "item.minecraft.orange_dye": "ნარინჯისფერი საღებავი",
  "item.minecraft.orange_harness": "ნარინჯისფერი აკაზმულობა",
  "item.minecraft.painting": "ნახატი",
  "item.minecraft.pale_oak_boat": "მკრთალი მუხის ნავი",
  "item.minecraft.pale_oak_chest_boat": "სკივრიანი მკრთალი მუხის ნავი",
  "item.minecraft.panda_spawn_egg": "პანდას გამოძახების კვერცხი",
  "item.minecraft.paper": "ქაღალდი",
  "item.minecraft.parched_spawn_egg": "მზისნაჭამის გამოძახების კვერცხი",
  "item.minecraft.parrot_spawn_egg": "თუთიყუშის გამოძახების კვერცხი",
  "item.minecraft.phantom_membrane": "ფანტომის მემბრანა",
  "item.minecraft.phantom_spawn_egg": "ფანტომის გამოძახების კვერცხი",
  "item.minecraft.pig_spawn_egg": "ღორის გამოძახების კვერცხი",
  "item.minecraft.piglin_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.piglin_banner_pattern.desc": "დინგი",
  "item.minecraft.piglin_banner_pattern.new": "დროშის მოხატულობა „დინგი“",
  "item.minecraft.piglin_brute_spawn_egg": "სასტიკი პიგლინის გამოძახების კვერცი",
  "item.minecraft.piglin_spawn_egg": "პიგლინის გამოძახების კვერცხი",
  "item.minecraft.pillager_spawn_egg": "ყაჩაღის გამოძახების კვერცხი",
  "item.minecraft.pink_bundle": "ვარდისფერი ტომარა",
  "item.minecraft.pink_dye": "ვარდისფერი საღებავი",
  "item.minecraft.pink_harness": "ვარდისფერი აკაზმულობა",
  "item.minecraft.pitcher_plant": "ქვევრის მცენარე",
  "item.minecraft.pitcher_pod": "ქვევრის პარკი",
  "item.minecraft.plenty_pottery_shard": "ჭურჭლის ნატეხი – დოვლათი",
  "item.minecraft.plenty_pottery_sherd": "ჭურჭლის ნატეხი – დოვლათი",
  "item.minecraft.poisonous_potato": "შხამიანი კარტოფილი",
  "item.minecraft.polar_bear_spawn_egg": "თეთრი დათვის გამოძახების კვერცხი",
  "item.minecraft.popped_chorus_fruit": "გახეთქილი ქორუსის ნაყოფი",
  "item.minecraft.porkchop": "უმი ღორის ხორცი",
  "item.minecraft.potato": "კარტოფილი",
  "item.minecraft.potion": "ხსნარი",
  "item.minecraft.potion.effect.awkward": "არეული ხსნარი",
  "item.minecraft.potion.effect.empty": "შეუქმნადი ხსნარი",
  "item.minecraft.potion.effect.fire_resistance": "ცეცხლმედეგობის ხსნარი",
  "item.minecraft.potion.effect.harming": "ზიანის ხსნარი",
  "item.minecraft.potion.effect.healing": "მკურნალობის ხსნარი",
  "item.minecraft.potion.effect.infested": "დაავადების ხსნარი",
  "item.minecraft.potion.effect.invisibility": "უჩინარობის ხსნარი",
  "item.minecraft.potion.effect.leaping": "ხტომის ხსნარი",
  "item.minecraft.potion.effect.levitation": "ლევიტაციის ხსნარი",
  "item.minecraft.potion.effect.luck": "იღბლის ხსნარი",
  "item.minecraft.potion.effect.mundane": "მდარე ხსნარი",
  "item.minecraft.potion.effect.night_vision": "ღამე ხედვის ხსნარი",
  "item.minecraft.potion.effect.oozing": "ლორწოების ხსნარი",
  "item.minecraft.potion.effect.poison": "მოწამლვის ხსნარი",
  "item.minecraft.potion.effect.regeneration": "რეგენერაციის ხსნარი",
  "item.minecraft.potion.effect.slow_falling": "სიმსუბუქის ხსნარი",
  "item.minecraft.potion.effect.slowness": "შენელების ხსნარი",
  "item.minecraft.potion.effect.strength": "სიძლიერის ხსნარი",
  "item.minecraft.potion.effect.swiftness": "სისწრაფის ხსნარი",
  "item.minecraft.potion.effect.thick": "სქელი ხსნარი",
  "item.minecraft.potion.effect.turtle_master": "კუს ოსტატობის ხსნარი",
  "item.minecraft.potion.effect.water": "წყლის ბოთლი",
  "item.minecraft.potion.effect.water_breathing": "წყალში სუნთქვის ხსნარი",
  "item.minecraft.potion.effect.weakness": "სისუსტის ხსნარი",
  "item.minecraft.potion.effect.weaving": "ქსოვის ხსნარი",
  "item.minecraft.potion.effect.wind_charged": "ქარიანობის ხსნარი",
  "item.minecraft.pottery_shard_archer": "ჭურჭლის ნატეხი – მშვილდოსანი",
  "item.minecraft.pottery_shard_arms_up": "ჭურჭლის ნატეხი – ხელები მაღლა",
  "item.minecraft.pottery_shard_prize": "ჭურჭლის ნატეხი – ჯილდო",
  "item.minecraft.pottery_shard_skull": "ჭურჭლის ნატეხი – ქალა",
  "item.minecraft.powder_snow_bucket": "სათლი ფხვიერი თოვლით",
  "item.minecraft.prismarine_crystals": "პრიზმარინის კრისტალი",
  "item.minecraft.prismarine_shard": "პრიზმარინის ნატეხი",
  "item.minecraft.prize_pottery_shard": "ჭურჭლის ნატეხი – ჯილდო",
  "item.minecraft.prize_pottery_sherd": "ჭურჭლის ნატეხი – ჯილდო",
  "item.minecraft.pufferfish": "მუცელნემსა",
  "item.minecraft.pufferfish_bucket": "მუცელნემსა სათლში",
  "item.minecraft.pufferfish_spawn_egg": "მუცელნემსას გამოძახების კვერცხი",
  "item.minecraft.pumpkin_pie": "გოგრის ღვეზელი",
  "item.minecraft.pumpkin_seeds": "გოგრის თესლი",
  "item.minecraft.purple_bundle": "იისფერი ტომარა",
  "item.minecraft.purple_dye": "იისფერი საღებავი",
  "item.minecraft.purple_harness": "იისფერი აკაზმულობა",
  "item.minecraft.quartz": "ნეზერ-კვარცი",
  "item.minecraft.rabbit": "უმი კურდღელი",
  "item.minecraft.rabbit_foot": "კურდღლის თათი",
  "item.minecraft.rabbit_hide": "კურდღლის ტყავი",
  "item.minecraft.rabbit_spawn_egg": "კურდღლის გამოძახების კვერცხი",
  "item.minecraft.rabbit_stew": "ჩაშუშული კურდღელი",
  "item.minecraft.raiser_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „მწარმოებელი“",
  "item.minecraft.ravager_spawn_egg": "მაოხრებლის გამოძახების კვერცხი",
  "item.minecraft.raw_copper": "ნედლი სპილენძი",
  "item.minecraft.raw_gold": "ნედლი ოქრო",
  "item.minecraft.raw_iron": "ნედლი რკინა",
  "item.minecraft.recovery_compass": "აღორძინების კომპასი",
  "item.minecraft.red_bundle": "წითელი ტომარა",
  "item.minecraft.red_dye": "წითელი საღებავი",
  "item.minecraft.red_harness": "წითელი აკაზმულობა",
  "item.minecraft.redstone": "რედსტოუნის მტვერი",
  "item.minecraft.resin_brick": "ფისის აგური",
  "item.minecraft.resin_clump": "ფისის შენადენი",
  "item.minecraft.rib_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.rib_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „ნეკნი“",
  "item.minecraft.rotten_flesh": "დამპალი ხორცი",
  "item.minecraft.saddle": "უნაგირი",
  "item.minecraft.salmon": "უმი ორაგული",
  "item.minecraft.salmon_bucket": "ორაგული სათლში",
  "item.minecraft.salmon_spawn_egg": "ორაგულის გამოძახების კვერცხი",
  "item.minecraft.scrape_pottery_sherd": "ჭურჭლის ნატეხი – ნაკაწრი",
  "item.minecraft.scute": "ბაკნის ნატეხი",
  "item.minecraft.sentry_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „ყარაული“",
  "item.minecraft.shaper_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „მაფორმებელი“",
  "item.minecraft.sheaf_pottery_shard": "ჭურჭლის ნატეხი – შეკვრა",
  "item.minecraft.sheaf_pottery_sherd": "ჭურჭლის ნატეხი – შეკვრა",
  "item.minecraft.shears": "მაკრატელი",
  "item.minecraft.sheep_spawn_egg": "ცხვრის გამოძახების კვერცხი",
  "item.minecraft.shelter_pottery_shard": "ჭურჭლის ნატეხი – თავშესაფარი",
  "item.minecraft.shelter_pottery_sherd": "ჭურჭლის ნატეხი – თავშესაფარი",
  "item.minecraft.shield": "ფარი",
  "item.minecraft.shield.black": "შავი ფარი",
  "item.minecraft.shield.blue": "ლურჯი ფარი",
  "item.minecraft.shield.brown": "ყავისფერი ფარი",
  "item.minecraft.shield.cyan": "ფირუზისფერი ფარი",
  "item.minecraft.shield.gray": "ნაცრისფერი ფარი",
  "item.minecraft.shield.green": "მწვანე ფარი",
  "item.minecraft.shield.light_blue": "ცისფერი ფარი",
  "item.minecraft.shield.light_gray": "ღია ნაცრისფერი ფარი",
  "item.minecraft.shield.lime": "სალათისფერი ფარი",
  "item.minecraft.shield.magenta": "იასამნისფერი ფარი",
  "item.minecraft.shield.orange": "ნარინჯისფერი ფარი",
  "item.minecraft.shield.pink": "ვარდისფერი ფარი",
  "item.minecraft.shield.purple": "იისფერი ფარი",
  "item.minecraft.shield.red": "წითელი ფარი",
  "item.minecraft.shield.white": "თეთრი ფარი",
  "item.minecraft.shield.yellow": "ყვითელი ფარი",
  "item.minecraft.shulker_shell": "შალკერის ბაკანი",
  "item.minecraft.shulker_spawn_egg": "შალკერის გამოძახების კვერცხი",
  "item.minecraft.sign": "აბრა",
  "item.minecraft.silence_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.silence_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „სიჩუმე“",
  "item.minecraft.silverfish_spawn_egg": "ქერცლოვანას გამოძახების კვერცხი",
  "item.minecraft.skeleton_horse_spawn_egg": "ჩონჩხი-ცხენის გამოძახების კვერცხი",
  "item.minecraft.skeleton_spawn_egg": "ჩონჩხის გამოძახების კვერცხი",
  "item.minecraft.skull_banner_pattern": "დროშის მოხატულობა",
  "item.minecraft.skull_banner_pattern.desc": "თავის ქალა",
  "item.minecraft.skull_banner_pattern.new": "დროშის მოხატულობა „თავის ქალა“",
  "item.minecraft.skull_pottery_shard": "ჭურჭლის ნატეხი – ქალა",
  "item.minecraft.skull_pottery_sherd": "ჭურჭლის ნატეხი – ქალა",
  "item.minecraft.slime_ball": "ლორწო",
  "item.minecraft.slime_spawn_egg": "ლორწოს გამოძახების კვერცხი",
  "item.minecraft.smithing_template": "სამჭედლო თარგი",
  "item.minecraft.smithing_template.applies_to": "გამოიყენება:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "მოათავსეთ ზოდი ან კრისტალი",
  "item.minecraft.smithing_template.armor_trim.applies_to": "აბჯარზე",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "მოათავსეთ აბჯრის ელემენტი",
  "item.minecraft.smithing_template.armor_trim.ingredients": "ზოდები და კრისტალები",
  "item.minecraft.smithing_template.ingredients": "მასალები:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "მოათავსეთ ნეზერიტის ზოდი",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "ალმასის აღჭურვილობაზე",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "მოათავსეთ ალმასის აბჯარი, იარაღი ან ხელსაწყო",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "ნეზერიტის ზოდი",
  "item.minecraft.smithing_template.upgrade": "გაუმჯობესება: ",
  "item.minecraft.sniffer_spawn_egg": "მყნოსველის გამოძახების კვერცხი",
  "item.minecraft.snort_pottery_shard": "ჭურჭლის ნატეხი – მყნოსველი",
  "item.minecraft.snort_pottery_sherd": "ჭურჭლის ნატეხი – მყნოსველი",
  "item.minecraft.snout_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.snout_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „დინგი“",
  "item.minecraft.snow_golem_spawn_egg": "თოვლის გოლემის გამოძახების კვერცხი",
  "item.minecraft.snowball": "თოვლის გუნდა",
  "item.minecraft.spectral_arrow": "სპექტრალური ისარი",
  "item.minecraft.spider_eye": "ობობის თვალი",
  "item.minecraft.spider_spawn_egg": "ობობის გამოძახების კვერცხი",
  "item.minecraft.spire_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.spire_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „შპილი“",
  "item.minecraft.splash_potion": "ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.awkward": "არეული ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.empty": "შეუქმნადი ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.fire_resistance": "ცეცხლმედეგობის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.harming": "ზიანის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.healing": "მკურნალობის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.infested": "დაავადების ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.invisibility": "უჩინარობის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.leaping": "ხტომის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.levitation": "ლევიტაციის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.luck": "იღბლიანობის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.mundane": "მდარე ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.night_vision": "ღამე ხედვის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.oozing": "ლორწობის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.poison": "მოწამლვის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.regeneration": "რეგენერაციის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.slow_falling": "სიმსუბუქის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.slowness": "შენელების ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.strength": "სიძლიერის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.swiftness": "სისწრაფის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.thick": "სქელი ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.turtle_master": "კუს ოსტატობის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.water": "ფეთქებადი წყლის ბოთლი",
  "item.minecraft.splash_potion.effect.water_breathing": "წყალში სუნთქვის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.weakness": "სისუსტის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.weaving": "ქსოვის ფეთქებადი ხსნარი",
  "item.minecraft.splash_potion.effect.wind_charged": "ქარიანობის ფეთქებადი ხსნარი",
  "item.minecraft.spruce_boat": "ნაძვის ნავი",
  "item.minecraft.spruce_chest_boat": "სკივრიანი ნაძვის ნავი",
  "item.minecraft.spyglass": "ჭოგრი",
  "item.minecraft.squid_spawn_egg": "კალმარის გამოძახების კვერცხი",
  "item.minecraft.stick": "ჯოხი",
  "item.minecraft.stone_axe": "ქვის ნაჯახი",
  "item.minecraft.stone_hoe": "ქვის თოხი",
  "item.minecraft.stone_pickaxe": "ქვის წერაქვი",
  "item.minecraft.stone_shovel": "ქვის ნიჩაბი",
  "item.minecraft.stone_spear": "ქვის შუბი",
  "item.minecraft.stone_sword": "ქვის ხმალი",
  "item.minecraft.stray_spawn_egg": "მაწანწალას გამოძახების კვერცხი",
  "item.minecraft.strider_spawn_egg": "ლავღონღლას გამოძახების კვერცხი",
  "item.minecraft.string": "ძაფი",
  "item.minecraft.sugar": "შაქარი",
  "item.minecraft.suspicious_stew": "იდუმალი წვნიანი",
  "item.minecraft.sweet_berries": "ტკბილი კენკრა",
  "item.minecraft.tadpole_bucket": "თავკომბალა სათლში",
  "item.minecraft.tadpole_spawn_egg": "თავკომბალას გამოძახების კვერცხი",
  "item.minecraft.tide_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.tide_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „მოზღვავება“",
  "item.minecraft.tipped_arrow": "დამუშავებული ისარი",
  "item.minecraft.tipped_arrow.effect.awkward": "დამუშავებული ისარი",
  "item.minecraft.tipped_arrow.effect.empty": "შეუქმნადი დამუშავებული ისარი",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "ცეცხლმედეგობის ისარი",
  "item.minecraft.tipped_arrow.effect.harming": "ზიანის ისარი",
  "item.minecraft.tipped_arrow.effect.healing": "მკურნალობის ისარი",
  "item.minecraft.tipped_arrow.effect.infested": "დაავადების ისარი",
  "item.minecraft.tipped_arrow.effect.invisibility": "უჩინარობის ისარი",
  "item.minecraft.tipped_arrow.effect.leaping": "ხტომის ისარი",
  "item.minecraft.tipped_arrow.effect.levitation": "ლევიტაციის ისარი",
  "item.minecraft.tipped_arrow.effect.luck": "იღბლიანობის ისარი",
  "item.minecraft.tipped_arrow.effect.mundane": "დამუშავებული ისარი",
  "item.minecraft.tipped_arrow.effect.night_vision": "ღამე ხედვის ისარი",
  "item.minecraft.tipped_arrow.effect.oozing": "ლორწოების ისარი",
  "item.minecraft.tipped_arrow.effect.poison": "მოწამლვის ისარი",
  "item.minecraft.tipped_arrow.effect.regeneration": "რეგენერაციის ისარი",
  "item.minecraft.tipped_arrow.effect.slow_falling": "სიმსუბუქის ისარი",
  "item.minecraft.tipped_arrow.effect.slowness": "შენელების ისარი",
  "item.minecraft.tipped_arrow.effect.strength": "სიძლიერის ისარი",
  "item.minecraft.tipped_arrow.effect.swiftness": "სისწრაფის ისარი",
  "item.minecraft.tipped_arrow.effect.thick": "დამუშავებული ისარი",
  "item.minecraft.tipped_arrow.effect.turtle_master": "კუს ოსტატობის ისარი",
  "item.minecraft.tipped_arrow.effect.water": "ფეთქებადი ისარი",
  "item.minecraft.tipped_arrow.effect.water_breathing": "წყალში სუნთქვის ისარი",
  "item.minecraft.tipped_arrow.effect.weakness": "სისუსტის ისარი",
  "item.minecraft.tipped_arrow.effect.weaving": "ქსოვის ისარი",
  "item.minecraft.tipped_arrow.effect.wind_charged": "ქარიანობის ისარი",
  "item.minecraft.tnt_minecart": "დინამიტიანი ურიკა",
  "item.minecraft.torchflower_seeds": "ჩირაღდანას თესლი",
  "item.minecraft.totem_of_undying": "უკვდავობის ტოტემი",
  "item.minecraft.trader_llama_spawn_egg": "ვაჭრის ლამის გამოძახების კვერცხი",
  "item.minecraft.trial_key": "გამოწვევების გასაღები",
  "item.minecraft.trident": "სამკაპი",
  "item.minecraft.tropical_fish": "ტროპიკული თევზი",
  "item.minecraft.tropical_fish_bucket": "ტროპიკული თევზი სათლში",
  "item.minecraft.tropical_fish_spawn_egg": "ტროპიკული თევზის გამოძახების კვერცხი",
  "item.minecraft.turtle_helmet": "კუს ბაკანი",
  "item.minecraft.turtle_scute": "კუს ბაკნის ნატეხი",
  "item.minecraft.turtle_spawn_egg": "კუს გამოძახების კვერცხი",
  "item.minecraft.vex_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.vex_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „მავნე“",
  "item.minecraft.vex_spawn_egg": "მავნეს გამოძახების კვერცხი",
  "item.minecraft.villager_spawn_egg": "მაცხოვრებლის გამოძახების კვერცხი",
  "item.minecraft.vindicator_spawn_egg": "გუშაგის გამოძახების კვერცხი",
  "item.minecraft.wandering_trader_spawn_egg": "მოგზაური ვაჭრის გამოძახების კვერცხი",
  "item.minecraft.ward_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.ward_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „დარაჯი“",
  "item.minecraft.warden_spawn_egg": "დარაჯის გამოძახების კვერცხი",
  "item.minecraft.warped_fungus_on_a_stick": "დაბრეცილი სოკო ანკესზე",
  "item.minecraft.water_bucket": "წყლიანი სათლი",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „გზამკვლევი“",
  "item.minecraft.wheat": "ხორბალი",
  "item.minecraft.wheat_seeds": "ხორბლის თესლი",
  "item.minecraft.white_bundle": "თეთრი ტომარა",
  "item.minecraft.white_dye": "თეთრი საღებავი",
  "item.minecraft.white_harness": "თეთრი აკაზმულობა",
  "item.minecraft.wild_armor_trim_smithing_template": "სამჭედლო თარგი",
  "item.minecraft.wild_armor_trim_smithing_template.new": "აბჯრის მოსართავი – „ველური“",
  "item.minecraft.wind_charge": "ქარის მუხტი",
  "item.minecraft.witch_spawn_egg": "კუდიანის გამოძახების კვერცხი",
  "item.minecraft.wither_skeleton_spawn_egg": "ვიზერ-ჩონჩხის გამოძახების კვერცხი",
  "item.minecraft.wither_spawn_egg": "ვიზერის გამოძახების კვერცხი",
  "item.minecraft.wolf_armor": "მგლის აბჯარი",
  "item.minecraft.wolf_spawn_egg": "მგლის გამოძახების კვერცხი",
  "item.minecraft.wooden_axe": "ხის ნაჯახი",
  "item.minecraft.wooden_hoe": "ხის თოხი",
  "item.minecraft.wooden_pickaxe": "ხის წერაქვი",
  "item.minecraft.wooden_shovel": "ხის ნიჩაბი",
  "item.minecraft.wooden_spear": "ხის შუბი",
  "item.minecraft.wooden_sword": "ხის ხმალი",
  "item.minecraft.writable_book": "წიგნი და ბუმბული",
  "item.minecraft.written_book": "დაწერილი წიგნი",
  "item.minecraft.yellow_bundle": "ყვითელი ტომარა",
  "item.minecraft.yellow_dye": "ყვითელი საღებავი",
  "item.minecraft.yellow_harness": "ყვითელი აკაზმულობა",
  "item.minecraft.zoglin_spawn_egg": "ზოგლინის გამოძახების კვერცხი",
  "item.minecraft.zombie_horse_spawn_egg": "ზომბი-ცხენის გამოძახების კვერცხი",
  "item.minecraft.zombie_nautilus_spawn_egg": "ზომბი-ნაუტილუსის გამოძახების კვერცხი",
  "item.minecraft.zombie_spawn_egg": "ზომბის გამოძახების კვერცხი",
  "item.minecraft.zombie_villager_spawn_egg": "ზომბი-მაცხოვრებლის გამოძახების კვერცხი",
  "item.minecraft.zombified_piglin_spawn_egg": "ზომბირებული პიგლინის გამოძახების კვერცხი"
}
export const ka_ge = items; 
